/* eslint-disable @typescript-eslint/no-explicit-any */
import { Browser } from '@capacitor/browser'
import { Haptics, ImpactStyle } from '@capacitor/haptics'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Center,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  ListItem,
  Radio,
  RadioGroup,
  Select,
  SimpleGrid,
  Skeleton,
  Spacer,
  Spinner,
  Stack,
  Switch,
  TabList,
  Tabs,
  Text,
  Textarea,
  UnorderedList,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { useContext, useEffect, useRef, useState } from 'react'
import { TbChevronRight } from 'react-icons/tb'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import ClassPackWalletCard from '../../components/cards/ClassPackWalletCard'
import EventDetailCard from '../../components/cards/EventDetailCard'
import {
  ArrowLeft,
  CircleDownArrow,
  Coins,
  CreditCard2,
  DecreasingLines,
  EyeOff,
  EyeOpen,
  Government,
  Logout,
  Search,
  TriangleAlert,
} from '../../components/icons/icons'
import TransactionActivity from '../../components/list/TransactionActivity'
import useMobile from '../../hooks/useMobile'
import { scrollbarStyle } from '../../theme/scrollbarStyles'

import CustomTab from '../../components/input/CustomTab'
import DatePickerModal from '../../components/modals/DatePickerModal'

import { format, subMonths, subWeeks, subYears } from 'date-fns'

import { FileOpener, FileOpenerOptions } from '@capacitor-community/file-opener'

import { getAuth } from 'firebase/auth'
import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from 'react-query'
import { AuthContext } from '../../App'
import { deleteUserProfile } from '../../api/admin/Users'
import {
  getBankAccount,
  getCoachReports,
  getNotificationSettings,
  getPayments,
  getPayouts,
  getTransactions,
  getTransactionsGraph,
  getWalletPackages,
  patchNotificationSettings,
  putBankAccount,
  putUserProfile,
  putUserSettings,
} from '../../api/user/settings/Settings'
import PolicyModal from '../../components/modals/PolicyModal'
import handleToast from '../../components/toast/handleToast'
import { EXAMPLE_POLICY, isSameDay } from './NotificationEvents'

import { FirebaseAuthentication } from '@capacitor-firebase/authentication'

import firebase from '../../api/firebase'
//import {  EmailAuthProvider , reauthenticateWithCredential } from "firebase/auth";

import { Capacitor } from '@capacitor/core'
import { Directory, Encoding, Filesystem } from '@capacitor/filesystem'

import validator from 'validator'
import { getUpcomingEvents } from '../../api/user/notifications/Notifications'
import { getCoachAvailability, putBooking } from '../../api/user/profile/Profile'
import { countries } from '../../components/countries/countries'
import InfinityGrid, { getInfinityPages } from '../../components/datagrid/InfinityGrid'
import PaymentChart from '../../components/display/PaymentChart'
import generateICS from '../../components/input/CalendarDownload'
import CustomTabs from '../../components/input/CustomTabs'
import InvalidInput from '../../components/input/InvalidInput'
import LocationPicker from '../../components/input/LocationPicker'
import LazyAvatar from '../../components/lazy/LazyAvatar'

import { postSessionToken } from '../../api/admin/Events'
import { userExists } from '../../api/auth'
import { getPackages } from '../../api/user/play/PlayCheckout'
import BlankState from '../../components/input/BlankState'
import CoachReportModal from '../../components/modals/CoachReportModal'
import { getSkillLevelDisplay } from '../../functions/Capitalize'
import { useProfilePhotoUpload } from '../../hooks/useProfilePhotoUpload'
import MediaPermissionRequiredModal from '../../components/modals/MediaPermissionRequiredModal'
import ProfileCropModal from '../../components/modals/ProfileCropModal'

export const checkFileSystemPermissions = async () => {
  const permission = await Filesystem.checkPermissions()
  console.debug('-----PERMISSIONS------', permission)
  if (permission.publicStorage === 'denied') return false
  if (permission.publicStorage !== 'granted') {
    const permission = await Filesystem.requestPermissions()
    if (permission.publicStorage !== 'granted') return false
    return true
  }
  return true
}

const SKILL_LEVELS: any = ['Beginner', 'Intermediate', 'Intermediate High', 'Advanced', 'Advanced 4.5+', 'Mixed-Level']

const SettingNavButton = ({
  label,
  url,
  isMobile,
  onClick,
}: {
  label: string
  url: string
  isMobile?: boolean
  onClick?: () => void
}) => {
  const location = useLocation()
  const isActive = location.pathname.includes(url)
  return (
    <Link to={!onClick ? url : ''} onClick={onClick}>
      <Flex
        p={isMobile ? '12px 0px' : '12px 20px'}
        mb={isMobile ? '10px' : '20px'}
        justifyContent="space-between"
        cursor="pointer"
        w={isMobile ? '100%' : undefined}
        h="44px"
        borderRadius="6px"
        color="#171C22"
        bg={isActive ? '#F5F7F9' : 'transparent'}
        fontWeight={isActive || isMobile ? '600' : '500'}
      >
        <Text>{label}</Text>
        {isMobile && <Icon as={TbChevronRight} w="20px" h="20px" />}
      </Flex>
    </Link>
  )
}

const NavSection = ({ isMobile }: { isMobile?: boolean }) => {
  const { logout, isHost } = useContext(AuthContext)

  const { isOpen: isRefundPolicyOpen, onClose: onRefundPolicyClose } = useDisclosure()

  return (
    <Box w={isMobile ? '100%' : '235px'} p={isMobile ? '0px' : '30px'}>
      <PolicyModal
        isOpen={isRefundPolicyOpen}
        onClose={onRefundPolicyClose}
        header="Terms and Policies"
        content={EXAMPLE_POLICY}
      />
      {!isMobile ? (
        <Text variant="title" mb="20px">
          Settings
        </Text>
      ) : (
        <></>
      )}

      <SettingNavButton label="Profile" url="/user/settings/profile" isMobile={isMobile} />
      <SettingNavButton label="Security" url="/user/settings/security" isMobile={isMobile} />
      <SettingNavButton label="Activity" url="/user/settings/activity" isMobile={isMobile} />
      <SettingNavButton label="Notifications" url="/user/settings/notifications" isMobile={isMobile} />
      {/* {!isHost && <SettingNavButton label="My Wallet" url="/user/settings/wallet" isMobile={isMobile} />} */}
      {isHost && <SettingNavButton label="Payments" url="/user/settings/payments" isMobile={isMobile} />}
      <SettingNavButton
        label="Terms & Policies"
        url="/user/settings/tp"
        onClick={() => window.open('https://lvbl.club/terms-of-service')}
        isMobile={isMobile}
      />

      <Flex
        p={isMobile ? '12px 0px' : '12px 20px'}
        mb={isMobile ? '10px' : '20px'}
        onClick={logout}
        mt={isMobile ? '50px' : undefined}
        h="44px"
        borderRadius="6px"
        cursor="pointer"
        color="#FF3B30"
        alignItems="center"
        gap="12px"
      >
        <Icon w="20px" h="20px" viewBox="0 0 20 20" fill="none">
          <Logout />
        </Icon>
        <Text>Log out</Text>
      </Flex>
    </Box>
  )
}

const COMP_LEVELS = ['National', 'Regional', 'Club', 'Recreational only'] //indexes
const GAME_FREQUENCIES = ['Less than four matches per month, never', 'More than 4 matches per month'] //indexes
const FITNESS_LEVELS = ['Excellent', 'Good', 'Normal', 'Low', 'Very low'] //indexes
const FORM_OF_TENNIS = ['Padel', 'Pickleball', 'Tennis', 'All of the above'] //WORDS
const LESSONS = ['No', 'Yes, one month', 'Yes, two months', 'Yes, one year', 'Yes, more than two years'] //indexes
const PAST_RACQUET_EXPERIENCE = ['No, never', 'Yes'] //indexes

const UserSettingsEditProfilePage = ({ isMobile }: { isMobile?: boolean }) => {
  const { user } = useContext(AuthContext)
  const queryClient = useQueryClient()

  const [formData, setFormData] = useState({
    name: '',
    region: '',
    age_range: '',
    gender: '',
    bio: '',
    instagram: '',
    website: '',
    linkedin: '',
    twitter: '',
    facebook: '',

    emergency_contact_name: '',
    emergency_contact_phone_number: '',
    emergency_contact_phone_number_prefix: '+1',
    address: '',
    address_location: null,

    comp_level: -1,
    skill_level: -1,
    fitness_level: -1,
    form_of_tennis: -1,
    game_frequency: -1,
    has_past_racquet_experience: -1,
    lessons: -1,
  })

  const [initialData, setInitialData] = useState<any>({})
  const triggerHapticFeedback = async (style = ImpactStyle.Heavy) => {
    Haptics.impact({ style }).catch(() => {})
  }
  const { logout } = useContext(AuthContext)

  const hasLowerNav = useMobile(600)

  // const authState = useAuthState(getAuth())
  // const userX = authState[0]
  // const error = authState[2]

  const profilePhotoUpload = useProfilePhotoUpload()

  function removeSocialMediaDomain(url: string | null) {
    if (url == null) return ''

    const socialMediaDomains = [
      'instagram.com',
      'linkedin.com',
      'facebook.com',
      'twitter.com',
      // Add more domains as needed
    ]

    const pattern = new RegExp(`https?://(?:www\\.)?(${socialMediaDomains.join('|')})/`, 'i')
    return url.replace(pattern, '')
  }

  useEffect(() => {
    // Helper function to extract country code and phone number
    const extractPhoneComponents = (fullPhoneNumber: string | null | undefined) => {
      if (!fullPhoneNumber) return { prefix: '+1', number: '' }

      // Find matching country code from the countries array
      const matchingCountry = countries.find((country) => fullPhoneNumber.startsWith(country.dial_code))

      if (matchingCountry) {
        const prefix = matchingCountry.dial_code
        const number = fullPhoneNumber.slice(prefix.length)
        return { prefix, number }
      }

      // Fallback: assume +1 and take the rest
      if (fullPhoneNumber.startsWith('+1')) {
        return { prefix: '+1', number: fullPhoneNumber.slice(2) }
      }

      // Default fallback
      return { prefix: '+1', number: fullPhoneNumber.replace(/^\+/, '') }
    }

    const phoneComponents = extractPhoneComponents(user?.member_profile?.emergency_contact_phone_number)

    const data = {
      name: user?.display_name ?? '',
      region: user?.member_profile?.region ?? '',
      age_range: user?.member_profile?.age_range ?? '',
      gender: user?.member_profile?.gender ?? '',
      instagram: removeSocialMediaDomain(user?.member_profile?.instagram) ?? '',
      bio: user?.member_profile?.bio ?? '',
      website: user?.member_profile?.website ?? '',
      linkedin: removeSocialMediaDomain(user?.member_profile?.linkedin) ?? '',
      twitter: removeSocialMediaDomain(user?.member_profile?.twitter) ?? '',
      facebook: removeSocialMediaDomain(user?.member_profile?.facebook) ?? '',

      emergency_contact_name: user?.member_profile?.emergency_contact_name ?? '',
      emergency_contact_phone_number: phoneComponents.number,
      emergency_contact_phone_number_prefix: phoneComponents.prefix,
      address: user?.member_profile?.address ?? '',
      address_location: user?.member_profile?.address_location ?? null,

      comp_level: user?.member_profile?.comp_level ?? -1,
      skill_level: user?.member_profile?.skill_level ?? -1,
      fitness_level: user?.member_profile?.fitness_level ?? -1,
      form_of_tennis:
        user?.member_profile?.form_of_tennis == null
          ? -1
          : user?.member_profile?.form_of_tennis == 'PAD'
            ? 0
            : user?.member_profile?.form_of_tennis == 'PIC'
              ? 1
              : user?.member_profile?.form_of_tennis == 'TEN'
                ? 2
                : 3,
      game_frequency:
        user?.member_profile?.game_frequency == null ? -1 : user?.member_profile?.game_frequency == 4 ? 1 : 0,
      has_past_racquet_experience:
        user?.member_profile?.has_past_racquet_experience == null
          ? -1
          : user?.member_profile?.has_past_racquet_experience
            ? 1
            : 0,
      lessons:
        user?.member_profile?.lessons == null
          ? -1
          : user?.member_profile?.lessons == 0
            ? 0
            : user?.member_profile?.lessons == 1
              ? 1
              : user?.member_profile?.lessons == 2
                ? 2
                : user?.member_profile?.lessons == 12
                  ? 3
                  : 4,
    }

    setInitialData(data)
    setFormData(data)
  }, [user])

  const toast = useToast()

  const deleteUserProfileMutation = useMutation(deleteUserProfile, {
    onSuccess: async () => {
      // Wait a bit to ensure the delete request is fully processed on the backend
      // This is especially important on mobile where network requests can be slower
      await new Promise((resolve) => setTimeout(resolve, 500))
      logout()
    },
    onError: (error: any) => {
      console.error('Failed to delete account:', error)
      handleToast(toast, 'Failed to delete account. Please try again.')
    },
  })

  const updateUserMutation = useMutation(['putUser'], putUserProfile, {
    onSuccess: () => {
      handleToast(toast, 'Profile updated')
      queryClient.invalidateQueries('getProfile')
      queryClient.invalidateQueries('auth')
    },
  })

  const [errors, setErrors] = useState({
    name: false,
    instagram: false,
    website: false,
    linkedin: false,
    twitter: false,
    facebook: false,
    emergency_contact_name: false,
    emergency_contact_phone_number: false,
    address: false,
  })

  const targets: any = {
    name: useRef<HTMLInputElement>(null),
    instagram: useRef<HTMLInputElement>(null),
    website: useRef<HTMLInputElement>(null),
    linkedin: useRef<HTMLInputElement>(null),
    twitter: useRef<HTMLInputElement>(null),
    facebook: useRef<HTMLInputElement>(null),
    emergency_contact_name: useRef<HTMLInputElement>(null),
    emergency_contact_phone_number: useRef<HTMLInputElement>(null),
    address: useRef<HTMLInputElement>(null),
  }

  const formatUniversalPhoneNumber = (phoneNumber: string) => {
    return phoneNumber.replace(/[^0-9]/g, '')
  }

  const formatAmericanPhoneNumber = (phoneNumber: string, prefix: string) => {
    if (prefix != '+1') return phoneNumber

    let finalNumber = '('
    if (phoneNumber.length > 0) finalNumber += phoneNumber.substring(0, 1)
    else return ''
    if (phoneNumber.length > 1) finalNumber += phoneNumber.substring(1, 2)
    else return finalNumber
    if (phoneNumber.length > 2) finalNumber += phoneNumber.substring(2, 3)
    else return finalNumber

    if (phoneNumber.length > 3) finalNumber += phoneNumber.substring(3, 4)
    else return finalNumber.substring(0, 4)
    if (phoneNumber.length > 4) finalNumber += phoneNumber.substring(4, 5)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 5)
    if (phoneNumber.length > 5) finalNumber += phoneNumber.substring(5, 6)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 6)

    if (phoneNumber.length > 6) finalNumber += phoneNumber.substring(6, 7)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7)
    if (phoneNumber.length > 7) finalNumber += phoneNumber.substring(7, 8)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 8)
    if (phoneNumber.length > 8) finalNumber += phoneNumber.substring(8, 9)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 9)
    if (phoneNumber.length > 9) finalNumber += phoneNumber.substring(9, 10)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 10)

    return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 11)
  }

  const validateData = () => {
    const websiteWithProtocol =
      formData.website.startsWith('http://') || formData.website.startsWith('https://')
        ? formData.website
        : `https://${formData.website}`

    const errors = {
      name: formData.name === '',
      instagram: false,
      website:
        formData.website.trim() === '' || formData.website === 'https://'
          ? false
          : !validator.isURL(websiteWithProtocol, { require_protocol: true }),
      linkedin: false,
      twitter: false,
      facebook: false,
      emergency_contact_name: false,
      emergency_contact_phone_number:
        formData.emergency_contact_phone_number !== '' &&
        !validator.isMobilePhone(
          formData.emergency_contact_phone_number_prefix +
          formatUniversalPhoneNumber(
            formatAmericanPhoneNumber(
              formData.emergency_contact_phone_number,
              formData.emergency_contact_phone_number_prefix
            )
          )
        ),
      address: false,
    }
    setFormData((prev) => ({ ...prev, website: websiteWithProtocol }))
    setErrors(errors)

    if (Object.values(errors).some((value: any) => value == true)) {
      const targetName = Object.entries(errors).find(([_, value]: any) => value == true)?.[0]

      if (targetName) targets[targetName]?.current?.scrollIntoView({ behavior: 'smooth' })
    }

    return !Object.values(errors).includes(true)
  }

  return (
    <Box position="relative">
      <ProfileCropModal
        image={profilePhotoUpload.cropImageSrc}
        isOpen={profilePhotoUpload.isCropModalOpen}
        onClose={profilePhotoUpload.closeCropModal}
        onSave={profilePhotoUpload.saveCroppedPhoto}
        isLoading={profilePhotoUpload.isUploading}
      />
      <MediaPermissionRequiredModal
        isOpen={profilePhotoUpload.isPermissionModalOpen}
        onClose={profilePhotoUpload.closePermissionModal}
      />

      <Box p={isMobile ? '20px' : '30px'}>
        {!isMobile && (
          <Text variant="title" mb="30px">
            Account
          </Text>
        )}

        <Text variant="title" fontSize="lg">
          Modify your profile
        </Text>
        <Text color="#3b3b3b" mb="30px">
          Manage your general account information
        </Text>

        <Text variant="title" fontSize="lg">
          Profile picture
        </Text>

        <Flex mt="14px" gap="16px" alignItems="center">
          <LazyAvatar width={60} height={60} border="1px solid #DCE2EA" src={user?.member_profile?.profile_image} />
          <Box position="relative">
            <Text variant="title" fontSize="md" lineHeight="20px">
              {user?.display_name}
            </Text>
            <Button
              variant="link"
              color="#3B4654"
              fontSize="xs"
              onClick={profilePhotoUpload.selectProfilePhoto}
            >
              Change profile picture
            </Button>
            <Input
              display="none"
              h="20px"
              position="absolute"
              bottom="0px"
              right="0px"
              ref={profilePhotoUpload.fileInputRef}
              type="file"
              accept="image/*"
              onChange={profilePhotoUpload.handleFileInputChange}
            />
          </Box>
        </Flex>

        <Text variant="title" fontSize="lg" mt="30px" ref={targets.name}>
          Full Name
        </Text>
        <Input
          maxW="600px"
          placeholder=""
          value={formData.name}
          onChange={(e: any) => setFormData({ ...formData, name: e.target.value })}
        />
        <InvalidInput isError={errors.name} override="Name cannot be empty" />

        <Text variant="title" fontSize="lg" mt="30px">
          Location
        </Text>
        <Input
          maxW="600px"
          placeholder=""
          value={formData.region}
          onChange={(e: any) => setFormData({ ...formData, region: e.target.value })}
        />

        <Text variant="title" fontSize="lg" mt="30px">
          Age Range
        </Text>
        <Select
          maxW="600px"
          placeholder=""
          variant="input"
          value={formData.age_range}
          onChange={(e: any) => setFormData({ ...formData, age_range: e.target.value })}
        >
          <option value={''}></option>
          <option value={18}>18-30</option>
          <option value={30}>30-40</option>
          <option value={40}>40-50</option>
          <option value={50}>50+</option>
        </Select>

        <Text variant="title" fontSize="lg" mt="30px">
          Gender
        </Text>
        <Select
          maxW="600px"
          placeholder=""
          variant="input"
          value={formData.gender}
          onChange={(e: any) => setFormData({ ...formData, gender: e.target.value })}
        >
          <option value={''}></option>
          <option value="M">Male</option>
          <option value="F">Female</option>
          <option value="X">Non-binary</option>
        </Select>

        <Text variant="title" fontSize="lg" mt="30px">
          Bio
        </Text>
        <Textarea
          sx={scrollbarStyle}
          placeholder="Type anything..."
          maxW="600px"
          fontSize="15px"
          fontWeight="400"
          lineHeight="21px"
          borderRadius="4px"
          bg="transparent"
          borderColor="#DCE2EA"
          borderWidth="1.5px"
          _placeholder={{ color: '#171C22', opacity: '40%' }}
          value={formData.bio}
          onChange={(e: any) => setFormData({ ...formData, bio: e.target.value })}
          rows={7}
          resize="none"
        />

        <Text variant="title" fontSize="lg" mt="30px" ref={targets.emergency_contact_name}>
          Emergency Contact Name{' '}
          <Text as="span" color="#7E8B9A" fontSize="sm">
            (Only seen by you and the LVBL administration)
          </Text>
        </Text>
        <Input
          maxW="600px"
          placeholder="Emergency Contact Name"
          value={formData.emergency_contact_name}
          onChange={(e: any) => setFormData({ ...formData, emergency_contact_name: e.target.value })}
        />
        <InvalidInput isError={errors.emergency_contact_name} override="Emergency contact name cannot be empty" />

        <Text variant="title" fontSize="lg" mt="30px" ref={targets.emergency_contact_phone_number}>
          Emergency Contact Phone Number{' '}
          <Text as="span" color="#7E8B9A" fontSize="sm">
            (Only seen by you and the LVBL administration)
          </Text>
        </Text>
        <Flex gap="5px" position="relative" maxW="600px">
          <Select
            w="120px"
            size="lg"
            name="emergency_contact_phone_number_prefix"
            borderRadius="4px"
            borderColor="#DCE2EA"
            borderWidth="1.5px"
            h="40px"
            _hover={{}}
            icon={
              <Icon w="18px" cursor="pointer" h="18px" color="black" viewBox="0 0 18 18">
                <Search />
              </Icon>
            }
            value={formData.emergency_contact_phone_number_prefix}
            onChange={(e: any) => setFormData({ ...formData, emergency_contact_phone_number_prefix: e.target.value })}
          >
            {countries.map((country: any, index: number) => {
              return (
                <option key={index} value={country.dial_code}>
                  {country.dial_code}
                </option>
              )
            })}
          </Select>
          <Input
            name="emergency_contact_phone_number"
            borderColor="#DCE2EA"
            borderWidth="1.5px"
            h="40px"
            onChange={(e: any) => {
              setFormData({ ...formData, emergency_contact_phone_number: formatUniversalPhoneNumber(e.target.value) })
            }}
            value={formatAmericanPhoneNumber(
              formData.emergency_contact_phone_number,
              formData.emergency_contact_phone_number_prefix
            )}
            size="lg"
            placeholder="(954) 444-4444"
            type="tel"
          />
        </Flex>
        <InvalidInput isError={errors.emergency_contact_phone_number} override="Invalid phone number" />

        <Text variant="title" fontSize="lg" mt="30px" ref={targets.address}>
          Home Address
        </Text>
        <Box border="1px solid #DCE2EA" borderRadius="4px" pl="4px" maxW="600px">
          <LocationPicker
            location={formData.address}
            setLocation={(v: string) => setFormData((prev) => ({ ...prev, address: v }))}
            placeholder="Enter your full home address"
            setCoordinates={(v: any) => {
              setFormData((prev) => ({ ...prev, address_location: v }))
            }}
            fontSize="16"
          />
        </Box>
        <InvalidInput isError={errors.address} override="Invalid address (minimum 10 characters)" />

        <Text variant="title" fontSize="lg" mt="30px" ref={targets.instagram}>
          Instagram
        </Text>
        <InputGroup maxW="600px">
          <InputLeftElement pointerEvents="none" width="50px">
            <Flex alignItems="center" gap="8px">
              <Text color="#7E8B9A" fontSize="md">
                @
              </Text>
              <Divider orientation="vertical" height="20px" />
            </Flex>
          </InputLeftElement>
          <Input
            paddingLeft="50px"
            placeholder="Your instagram handle here"
            value={formData.instagram}
            onChange={(e: any) => setFormData({ ...formData, instagram: e.target.value })}
          />
        </InputGroup>
        <InvalidInput isError={errors.instagram} override="This is not a valid instagram link" />

        <Text variant="title" fontSize="lg" mt="30px" ref={targets.website}>
          Your Website
        </Text>
        <InputGroup maxW="600px">
          <InputLeftElement pointerEvents="none" width="80px">
            <Flex alignItems="center" gap="8px">
              <Text color="#7E8B9A" fontSize="md">
                https://
              </Text>
              <Divider orientation="vertical" height="20px" />
            </Flex>
          </InputLeftElement>
          <Input
            paddingLeft="80px"
            placeholder="www.website.com"
            value={formData.website.replace(/^https?:\/\//, '')} // Display without "http://" or "https://"
            onChange={(e: any) => {
              const value = e.target.value
              setFormData((prevData) => ({
                ...prevData,
                website: value, // Store the raw input value
              }))
            }}
          />
        </InputGroup>

        <InvalidInput isError={errors.website} override="This is not a valid website link" />

        <Text variant="title" fontSize="lg" mt="30px" ref={targets.linkedin}>
          LinkedIn
        </Text>
        <InputGroup maxW="600px">
          <InputLeftElement pointerEvents="none" width="50px">
            <Flex alignItems="center" gap="8px">
              <Text color="#7E8B9A" fontSize="md">
                @
              </Text>
              <Divider orientation="vertical" height="20px" />
            </Flex>
          </InputLeftElement>
          <Input
            paddingLeft="50px"
            placeholder="Your linkedin handle here"
            value={formData.linkedin}
            onChange={(e: any) => setFormData({ ...formData, linkedin: e.target.value })}
          />
        </InputGroup>
        <InvalidInput isError={errors.linkedin} override="This is not a valid linkedin link" />

        <Text variant="title" fontSize="lg" mt="30px" ref={targets.twitter}>
          X
        </Text>
        <InputGroup maxW="600px">
          <InputLeftElement pointerEvents="none" width="50px">
            <Flex alignItems="center" gap="8px">
              <Text color="#7E8B9A" fontSize="md">
                @
              </Text>
              <Divider orientation="vertical" height="20px" />
            </Flex>
          </InputLeftElement>
          <Input
            paddingLeft="50px"
            placeholder="Your X handle here"
            value={formData.twitter}
            onChange={(e: any) => setFormData({ ...formData, twitter: e.target.value })}
          />
        </InputGroup>
        <InvalidInput isError={errors.twitter} override="This is not a valid X link" />

        <Text variant="title" fontSize="md" lineHeight="19px" mt="25px" mb="20px">
          Fitness Level
        </Text>
        <CustomTabs
          name="fitnessLevel"
          value={formData.fitness_level}
          onChange={(v) => setFormData({ ...formData, fitness_level: v })}
          choices={FITNESS_LEVELS}
        />

        <Text variant="title" fontSize="md" lineHeight="19px" mt="25px" mb="20px">
          Tennis Form
        </Text>
        <CustomTabs
          name="tennisForm"
          value={formData.form_of_tennis}
          onChange={(v) => setFormData({ ...formData, form_of_tennis: v })}
          choices={FORM_OF_TENNIS}
        />

        <Text variant="title" fontSize="md" lineHeight="19px" mt="25px" mb="20px">
          Skill Level
        </Text>
        <CustomTabs
          name="tennisForm"
          value={formData.skill_level}
          onChange={(v) => setFormData({ ...formData, skill_level: v })}
          choices={SKILL_LEVELS}
        />

        <Text variant="title" fontSize="md" lineHeight="19px" mt="25px" mb="20px">
          Game Frequency
        </Text>
        <CustomTabs
          name="tennisForm"
          value={formData.game_frequency}
          onChange={(v) => setFormData({ ...formData, game_frequency: v })}
          choices={GAME_FREQUENCIES}
        />

        <Text variant="title" fontSize="md" lineHeight="19px" mt="25px" mb="20px">
          Previous Racqet Experience
        </Text>
        <CustomTabs
          name="tennisForm"
          value={formData.has_past_racquet_experience}
          onChange={(v) => setFormData({ ...formData, has_past_racquet_experience: v })}
          choices={PAST_RACQUET_EXPERIENCE}
        />

        <Text variant="title" fontSize="md" lineHeight="19px" mt="25px" mb="20px">
          Advanced 4.5+ Level
        </Text>
        <CustomTabs
          name="tennisForm"
          value={formData.comp_level}
          onChange={(v) => setFormData({ ...formData, comp_level: v })}
          choices={COMP_LEVELS}
        />

        <Text variant="title" fontSize="md" lineHeight="19px" mt="25px" mb="20px">
          Lessons
        </Text>
        <CustomTabs
          name="tennisForm"
          value={formData.lessons}
          onChange={(v) => setFormData({ ...formData, lessons: v })}
          choices={LESSONS}
        />
        <Spacer h={initialData == formData ? '20px' : '48px'} />

        {(initialData == formData || isMobile) && (
          <Button
            variant="heavy"
            onClick={() => {
              if (validateData()) {
                updateUserMutation.mutate({
                  ...formData,

                  instagram: formData.instagram === '' ? '' : 'https://instagram.com/' + formData.instagram,
                  linkedin: formData.linkedin === '' ? '' : 'https://linkedin.com/' + formData.linkedin,
                  twitter: formData.twitter === '' ? '' : 'https://twitter.com/' + formData.twitter,
                  facebook: formData.facebook === '' ? '' : 'https://facebook.com/' + formData.facebook,
                  website:
                    formData.website === '' || formData.website === 'https://' || formData.website === 'http://'
                      ? ''
                      : formData.website.startsWith('http://') || formData.website.startsWith('https://')
                        ? formData.website
                        : `https://${formData.website}`,

                  emergency_contact_name: formData.emergency_contact_name,
                  emergency_contact_phone_number:
                    formData.emergency_contact_phone_number === ''
                      ? ''
                      : formData.emergency_contact_phone_number_prefix +
                      formatUniversalPhoneNumber(
                        formatAmericanPhoneNumber(
                          formData.emergency_contact_phone_number,
                          formData.emergency_contact_phone_number_prefix
                        )
                      ),
                  address: formData.address,
                  address_location: formData.address === '' ? null : formData.address_location,

                  age_range: formData.age_range === '' ? null : formData.age_range,
                  gender: formData.gender === '' ? null : formData.gender,

                  skill_level: formData.skill_level == -1 ? null : formData.skill_level,
                  comp_level: formData.comp_level == -1 ? null : formData.comp_level,
                  has_past_racquet_experience:
                    formData.has_past_racquet_experience == -1
                      ? null
                      : formData.has_past_racquet_experience
                        ? true
                        : false,
                  game_frequency: formData.game_frequency == -1 ? null : formData.game_frequency == 1 ? 4 : 0,
                  lessons:
                    formData.lessons == -1
                      ? null
                      : formData.lessons == 0
                        ? 0
                        : formData.lessons == 1
                          ? 1
                          : formData.lessons == 2
                            ? 2
                            : formData.lessons == 3
                              ? 12
                              : 24,
                  fitness_level: formData.fitness_level == -1 ? null : formData.fitness_level,
                  form_of_tennis:
                    formData.form_of_tennis == -1
                      ? null
                      : formData.form_of_tennis == 0
                        ? 'PAD'
                        : formData.form_of_tennis == 1
                          ? 'PIC'
                          : formData.form_of_tennis == 2
                            ? 'TEN'
                            : 'ALL',
                })
              }
            }}
            isLoading={updateUserMutation.isLoading}
            isDisabled={initialData == formData}
          >
            Save
          </Button>
        )}
      </Box>

      {initialData != formData && !isMobile && (
        <Box
          position="sticky"
          bottom={hasLowerNav ? '0px' : '0px'}
          bgColor="white"
          w="100%"
          //boxShadow="0px -4px 10px rgba(0, 0, 0, 0.04)"
          pt="16px"
          pb="16px"
          //borderTopWidth="1px" borderColor="#DCE2EA"
          pl="30px"
        >
          <Button
            variant="heavy"
            onClick={() => {
              if (validateData()) {
                updateUserMutation.mutate({
                  ...formData,

                  instagram: formData.instagram === '' ? '' : 'https://instagram.com/' + formData.instagram,
                  linkedin: formData.linkedin === '' ? '' : 'https://linkedin.com/' + formData.linkedin,
                  twitter: formData.twitter === '' ? '' : 'https://twitter.com/' + formData.twitter,
                  facebook: formData.facebook === '' ? '' : 'https://facebook.com/' + formData.facebook,
                  website:
                    formData.website === '' || formData.website === 'https://' || formData.website === 'http://'
                      ? ''
                      : formData.website.startsWith('http://') || formData.website.startsWith('https://')
                        ? formData.website
                        : `https://${formData.website}`,

                  emergency_contact_name: formData.emergency_contact_name,
                  emergency_contact_phone_number:
                    formData.emergency_contact_phone_number === ''
                      ? ''
                      : formData.emergency_contact_phone_number_prefix +
                      formatUniversalPhoneNumber(
                        formatAmericanPhoneNumber(
                          formData.emergency_contact_phone_number,
                          formData.emergency_contact_phone_number_prefix
                        )
                      ),
                  address: formData.address,
                  address_location: formData.address === '' ? null : formData.address_location,

                  age_range: formData.age_range === '' ? null : formData.age_range,
                  gender: formData.gender === '' ? null : formData.gender,

                  skill_level: formData.skill_level == -1 ? null : formData.skill_level,
                  comp_level: formData.comp_level == -1 ? null : formData.comp_level,
                  has_past_racquet_experience:
                    formData.has_past_racquet_experience == -1
                      ? null
                      : formData.has_past_racquet_experience
                        ? true
                        : false,
                  game_frequency: formData.game_frequency == -1 ? null : formData.game_frequency == 1 ? 4 : 0,
                  lessons:
                    formData.lessons == -1
                      ? null
                      : formData.lessons == 0
                        ? 0
                        : formData.lessons == 1
                          ? 1
                          : formData.lessons == 2
                            ? 2
                            : formData.lessons == 3
                              ? 12
                              : 24,
                  fitness_level: formData.fitness_level == -1 ? null : formData.fitness_level,
                  form_of_tennis:
                    formData.form_of_tennis == -1
                      ? null
                      : formData.form_of_tennis == 0
                        ? 'PAD'
                        : formData.form_of_tennis == 1
                          ? 'PIC'
                          : formData.form_of_tennis == 2
                            ? 'TEN'
                            : 'ALL',
                })
              }
            }}
            isLoading={updateUserMutation.isLoading}
            isDisabled={initialData == formData}
          >
            Save
          </Button>
        </Box>
      )}
      <Flex direction="column" alignItems="flex-start" m="20px" justifyContent={'start'}>
        <Text mb="10px" color="red.500" fontWeight="600">
          After you click the delete button, your account will be forever deleted, and you will be immediately logged
          out! You will also lose access to all your data.
        </Text>
        <Button
          colorScheme="red"
          variant="solid"
          onClick={() => {
            triggerHapticFeedback(ImpactStyle.Medium)
            deleteUserProfileMutation.mutate()
          }}
        >
          Delete Account
        </Button>
      </Flex>
    </Box>
  )
}

const UserSettingsSecurityPage = ({ isMobile }: { isMobile?: boolean }) => {
  const { user, signInWithEmailAndPassword } = useContext(AuthContext)

  //const queryClient = useQueryClient()

  const [formData, setFormData] = useState({
    phone_number: user?.phone_number ?? '',
    email: user?.email ?? '',
    password: '',
  })

  useEffect(() => {
    console.debug('USER', user?.phone_number, user?.email)
    setFormData({
      password: '**********',
      phone_number: user?.phone_number ?? '',
      email: user?.email ?? '',
    })
  }, [user])

  const handleLogin = (email: string, password: string) => {
    signInWithEmailAndPassword(email, password)
  }

  async function isPasswordCorrect(password: string): Promise<boolean> {
    try {
      const result = await FirebaseAuthentication.signInWithEmailAndPassword({
        email: user?.email ?? '',
        password: password,
      })
      //return result.user;
      console.debug(result)
      getAuth(firebase)
      // const user : User | null  = auth.currentUser

      //const credential = EmailAuthProvider.credential(user?.email ?? "", password)

      // if (user)
      //     await reauthenticateWithCredential(user, credential)
      // else return false

      return true
    } catch (error) {
      console.debug(error)
      // If there's an error during re-authentication, the password is incorrect

      return false
    }
  }

  const [inputs, setInputs] = useState(['', '', ''])

  const [currentLoad, setCurrentLoad] = useState(-1)

  const [errors, setErrors] = useState({
    first: false,
    second: false,
    third: false,
  })

  const queryClient = useQueryClient()

  const [passwordError, setPasswordError] = useState(false)

  const editUserMutation = useMutation(['putUserSettings'], putUserSettings, {
    onSuccess: () => {
      queryClient.invalidateQueries('auth')

      if (currentLoad == 1) {
        handleLogin(inputs[2], inputs[1])
      } else if (currentLoad == 2) {
        handleLogin(user?.email ?? '', inputs[2])
      }

      setCurrentLoad(-1)
    },
  })

  const emailExists = useQuery(['emailExists', inputs[2]], () => userExists(inputs[2]), {
    enabled: currentLoad == 1 && inputs[2] != '',
    retry: false,
  })

  const formatAmericanPhoneNumber = (phoneNumber: string, prefix: string) => {
    if (prefix != '+1') return phoneNumber

    let finalNumber = '('
    if (phoneNumber.length > 0) finalNumber += phoneNumber.substring(0, 1)
    else return ''
    if (phoneNumber.length > 1) finalNumber += phoneNumber.substring(1, 2)
    else return finalNumber
    if (phoneNumber.length > 2) finalNumber += phoneNumber.substring(2, 3)
    else return finalNumber

    if (phoneNumber.length > 3) finalNumber += phoneNumber.substring(3, 4)
    else return finalNumber.substring(0, 4)
    if (phoneNumber.length > 4) finalNumber += phoneNumber.substring(4, 5)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 5)
    if (phoneNumber.length > 5) finalNumber += phoneNumber.substring(5, 6)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 6)

    if (phoneNumber.length > 6) finalNumber += phoneNumber.substring(6, 7)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7)
    if (phoneNumber.length > 7) finalNumber += phoneNumber.substring(7, 8)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 8)
    if (phoneNumber.length > 8) finalNumber += phoneNumber.substring(8, 9)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 9)
    if (phoneNumber.length > 9) finalNumber += phoneNumber.substring(9, 10)
    else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 10)

    return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 11)
  }

  const formatUniversalPhoneNumber = (phoneNumber: string) => {
    return phoneNumber.replace(/[^0-9]/g, '')
  }

  useEffect(() => {
    setErrors({
      first: false,
      second: false,
      third: false,
    })
    setInputs(['', '', ''])
    setPasswordError(false)
  }, [currentLoad])

  const validateData = () => {
    const errors = {
      first:
        currentLoad == 0
          ? !validator.isMobilePhone(index + formatUniversalPhoneNumber(formatAmericanPhoneNumber(inputs[0], index)))
          : currentLoad == 1
            ? inputs[0] !== user?.email
            : !validator.isStrongPassword(inputs[0]),
      second: currentLoad == 0 ? false : !validator.isStrongPassword(inputs[1]),
      third:
        currentLoad == 0
          ? false
          : currentLoad == 1
            ? !validator.isEmail(inputs[2]) || !emailExists.isSuccess
            : inputs[2] !== inputs[1],
    }

    setErrors(errors)
    return !Object.values(errors).includes(true)
  }

  const [index, setIndex] = useState('+1')

  const selectRef = useRef<HTMLSelectElement>(null)
  const [selectWidth, setSelectWidth] = useState(0)

  const handleResize = () => {
    if (selectRef.current) {
      setSelectWidth(selectRef.current.clientWidth)
    }
  }

  useEffect(() => {
    // Initial width calculation
    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    // Ensuring the DOM is updated before getting the width
    if (selectRef.current) {
      setSelectWidth(selectRef.current.clientWidth)
    }
  }, [selectRef.current])

  useEffect(() => {
    handleResize()
  }, [])

  function isNumeric(str: string) {
    // Using regular expression to check if the string consists of only digits
    return /^\d+$/.test(str)
  }

  const [showPw, setShowPw] = useState(false)
  const [showPw2, setShowPw2] = useState(false)
  const [showPw3, setShowPw3] = useState(false)

  return (
    <>
      {currentLoad == -1 ? (
        <>
          {!isMobile && (
            <Text variant="title" mb="30px">
              Security
            </Text>
          )}

          <Text variant="title" fontSize="lg">
            Account details
          </Text>
          <Text color="#3b3b3b" mb="30px">
            Manage your account details
          </Text>

          <Text variant="title" fontSize="lg" mt="30px">
            Phone number
          </Text>
          <Flex mt="4px" w={isMobile ? '100%' : '300px'} justifyContent="space-between">
            <Text variant="subtle">
              {formData.phone_number.length == 0
                ? 'No phone number'
                : formData.phone_number.startsWith('+1')
                  ? '+1 ' + formatAmericanPhoneNumber(formData.phone_number.substring(2), '+1')
                  : formData.phone_number}
            </Text>
            <Button
              variant="link"
              onClick={() => {
                setCurrentLoad(0)
              }}
            >
              Edit
            </Button>
          </Flex>

          <Text variant="title" fontSize="lg" mt="30px">
            Email
          </Text>
          <Flex mt="4px" w={isMobile ? '100%' : '300px'} justifyContent="space-between">
            <Text variant="subtle">{formData.email}</Text>
            {!user?.member_profile?.has_social_auth && (
              <Button
                variant="link"
                onClick={() => {
                  setCurrentLoad(1)
                }}
              >
                Edit
              </Button>
            )}
          </Flex>

          <Text variant="title" fontSize="lg" mt="30px">
            Password
          </Text>
          <Flex mt="4px" w={isMobile ? '100%' : '300px'} justifyContent="space-between">
            <Text variant="subtle">**********</Text>

            {!user?.member_profile?.has_social_auth && (
              <Button
                variant="link"
                onClick={() => {
                  setCurrentLoad(2)
                }}
              >
                Edit
              </Button>
            )}
          </Flex>

          {user?.member_profile?.has_social_auth && (
            <Text variant="subtle" mt="20px">
              This account is linked to a third party authentication provider.
            </Text>
          )}
        </>
      ) : (
        <Box w="500px" maxWidth="100%">
          <IconButton
            minW="32px"
            h="32px"
            variant="light"
            aria-label="back"
            onClick={() => setCurrentLoad(-1)}
            icon={
              <Icon width="20px" height="19px" viewBox="0 0 23 20">
                <ArrowLeft color="#171C22" />
              </Icon>
            }
          />
          <Text mt="8px" fontSize="md" color="#171C22">
            Change your {currentLoad == 0 ? 'phone number' : currentLoad == 1 ? 'email' : 'password'} here
          </Text>

          {currentLoad === 0 && (
            <FormControl mb="20px" isInvalid={errors.first} mt="25px">
              <FormLabel>New Phone Number</FormLabel>
              <Flex gap="5px" position="relative">
                <Select
                  w="140px"
                  size="lg"
                  name="phone_number_prefix"
                  borderRadius="4px"
                  borderColor="black"
                  borderWidth="1px"
                  h="40px"
                  color="white"
                  ref={selectRef}
                  cursor={'pointer'}
                  _hover={{}}
                  icon={
                    <Icon w="18px" cursor="pointer" h="18px" color="black" viewBox="0 0 18 18">
                      <Search />
                    </Icon>
                  }
                  value={index}
                  onChange={(e: any) => setIndex(e.target.value)}
                >
                  {countries.map((country: any, index: number) => {
                    return (
                      <option key={index} value={country.dial_code}>
                        {country.dial_code} ({country.name})
                      </option>
                    )
                  })}
                </Select>
                <Flex
                  position="absolute"
                  h="40px"
                  maxH="40px"
                  minH="40px"
                  bgColor="white"
                  left="4px"
                  w={'calc(' + selectWidth + 'px - 34px)'}
                  borderTop="1px solid black"
                  borderBottom="1px solid black"
                //w="75px"
                >
                  <Input
                    border="0"
                    size="lg"
                    h="38px"
                    maxH="38px"
                    minH="38px"
                    name="phone_number_prefix"
                    value={index}
                    onChange={(e) => {
                      if (
                        e.target.value.charAt(0) == '+' &&
                        (e.target.value.length == 1 || isNumeric(e.target.value.substring(1)))
                      )
                        setIndex(e.target.value)
                    }}
                  />
                </Flex>

                <Input
                  name="phone_number"
                  borderColor="black"
                  borderWidth="1px"
                  h="40px"
                  onChange={(e: any) => {
                    setInputs([formatUniversalPhoneNumber(e.target.value), inputs[1], inputs[2]])

                    //setData({...data,phone_number:formatUniversalPhoneNumber(e.target.value)})

                    // if (validatePhoneNumber(formatPhoneNumber(e.target.value)) || e.target.value.length == 0 || e.target.value == "(") {
                    //     handleChangeData(e)
                    // }
                  }}
                  value={formatAmericanPhoneNumber(inputs[0], index)}
                  size="lg"
                  placeholder="(954) 444-4444"
                  type="tel"
                />
              </Flex>

              <FormErrorMessage>Invalid phone number</FormErrorMessage>
            </FormControl>
          )}
          {currentLoad === 1 && (
            <>
              <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
                Current Email
              </Text>
              <Input
                borderColor="black"
                placeholder={'example@email.com'}
                type="email"
                value={inputs[0]}
                onChange={(e) => setInputs([e.target.value, inputs[1], inputs[2]])}
              />
              <InvalidInput isError={errors.first} override={"Emails don't match"} />
              <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
                Current password
              </Text>
              <Input
                borderColor="black"
                placeholder={currentLoad == 1 ? 'example@email.com' : ''}
                type="email"
                value={inputs[1]}
                onChange={(e) => setInputs([inputs[0], e.target.value, inputs[2]])}
              />
              {!(currentLoad == 1 && passwordError) && (
                <InvalidInput
                  isError={errors.second}
                  override="Password must include at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
                />
              )}
              <InvalidInput isError={passwordError} override="Incorrect Password" />

              <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
                New email
              </Text>
              <Input
                borderColor="black"
                placeholder="example@email.com"
                type="email"
                value={inputs[2]}
                onChange={(e) => setInputs([inputs[0], inputs[1], e.target.value])}
              />
              <InvalidInput
                isError={errors.third && (currentLoad != 1 || !emailExists.isSuccess || !validator.isEmail(inputs[2]))}
                override={
                  !emailExists.isSuccess && !emailExists.isLoading && inputs[2] != ''
                    ? 'Email already exists'
                    : !validator.isEmail(inputs[2])
                      ? 'Invalid email'
                      : ''
                }
              />
            </>
          )}

          {currentLoad === 2 && (
            <>
              <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
                Current Password
              </Text>
              <InputGroup size="md">
                <Input
                  name="password"
                  onChange={(e) => setInputs([e.target.value, inputs[1], inputs[2]])}
                  value={inputs[0]}
                  size="md"
                  placeholder=""
                  type={showPw ? 'text' : 'password'}
                />
                <InputRightElement width="4.5rem">
                  <IconButton
                    aria-label="show / hide password"
                    variant="unstyled"
                    onClick={() => setShowPw(!showPw)}
                    icon={
                      <Icon w="22px" h="22px" color="black">
                        {showPw ? <EyeOff /> : <EyeOpen />}
                      </Icon>
                    }
                  />
                </InputRightElement>
              </InputGroup>
              {/* <Input
                  borderColor="black"
                  placeholder=""
                  type= "password"
                  value={inputs[0]}
                  onChange={(e) =>
                    setInputs([e.target.value, inputs[1], inputs[2]])
                  }
                /> */}
              {!(currentLoad == 2 && passwordError) && (
                <InvalidInput isError={errors.first} override={'Invalid password'} />
              )}
              {/* <InvalidInput
                  isError={currentLoad == 2 && passwordError}
                  override="Incorrect Password"
                /> */}
              <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
                New password
              </Text>
              <InputGroup size="md">
                <Input
                  name="password"
                  onChange={(e) => setInputs([inputs[0], e.target.value, inputs[2]])}
                  value={inputs[1]}
                  size="md"
                  placeholder=""
                  type={showPw2 ? 'text' : 'password'}
                />
                <InputRightElement width="4.5rem">
                  <IconButton
                    aria-label="show / hide password"
                    variant="unstyled"
                    onClick={() => setShowPw2(!showPw2)}
                    icon={
                      <Icon w="22px" h="22px" color="black">
                        {showPw2 ? <EyeOff /> : <EyeOpen />}
                      </Icon>
                    }
                  />
                </InputRightElement>
              </InputGroup>
              {/* <Input
                  borderColor="black"
                  placeholder=""
                  type="password"
                  value={inputs[1]}
                  onChange={(e) =>
                    setInputs([inputs[0], e.target.value, inputs[2]])
                  }
                /> */}
              {!passwordError && (
                <InvalidInput
                  isError={errors.second}
                  override="Password must include at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
                />
              )}
              <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
                Confirm new password
              </Text>
              <InputGroup size="md">
                <Input
                  name="password"
                  onChange={(e) => setInputs([inputs[0], inputs[1], e.target.value])}
                  value={inputs[2]}
                  size="md"
                  placeholder=""
                  type={showPw3 ? 'text' : 'password'}
                />
                <InputRightElement width="4.5rem">
                  <IconButton
                    aria-label="show / hide password"
                    variant="unstyled"
                    onClick={() => setShowPw3(!showPw3)}
                    icon={
                      <Icon w="22px" h="22px" color="black">
                        {showPw3 ? <EyeOff /> : <EyeOpen />}
                      </Icon>
                    }
                  />
                </InputRightElement>
              </InputGroup>
              {/* <Input
                  borderColor="black"
                  placeholder= ""
                  type="password"
                  value={inputs[2]}
                  onChange={(e) =>
                    setInputs([inputs[0], inputs[1], e.target.value])
                  }
                /> */}
              <InvalidInput isError={errors.third && currentLoad === 2} override="Passwords don't match" />
            </>
          )}

          {/* {currentLoad > 0 && (
              <>
                <Text
                  variant="title"
                  fontSize={isMobile ? "md" : "lg"}
                  lineHeight="19px"
                  mt="25px"
                  mb="10px"
                >
                  {currentLoad == 1 ? "Current password" : "New password"}
                </Text>
                <Input
                  borderColor="black"
                  placeholder={currentLoad == 1 ? "example@email.com" : ""}
                  type={currentLoad != 2 ? "" : "password"}
                  value={inputs[1]}
                  onChange={(e) =>
                    setInputs([inputs[0], e.target.value, inputs[2]])
                  }
                />
                {!(currentLoad == 1 && passwordError) && (
                  <InvalidInput
                    isError={errors.second}
                    override="Password must include at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
                  />
                )}
                <InvalidInput
                  isError={currentLoad == 1 && passwordError}
                  override="Incorrect Password"
                />
              </>
            )}

            {currentLoad > 0 && (
              <>
                <Text
                  variant="title"
                  fontSize={isMobile ? "md" : "lg"}
                  lineHeight="19px"
                  mt="25px"
                  mb="10px"
                >
                  {currentLoad == 1 ? "New email" : "Confirm new password"}
                </Text>
                <Input
                  borderColor="black"
                  placeholder={currentLoad == 1 ? "example@email.com" : ""}
                  type={currentLoad == 1 ? "" : "password"}
                  value={inputs[2]}
                  onChange={(e) =>
                    setInputs([inputs[0], inputs[1], e.target.value])
                  }
                />
                <InvalidInput
                  isError={
                    errors.third &&
                    (currentLoad != 1 ||
                      !emailExists.isSuccess ||
                      !validator.isEmail(inputs[2]))
                  }
                  override={
                    currentLoad == 1
                      ? !emailExists.isSuccess &&
                        !emailExists.isLoading &&
                        inputs[2] != ""
                        ? "Email already exists"
                        : !validator.isEmail(inputs[2])
                        ? "Invalid email"
                        : ""
                      : "Passwords don't match"
                  }
                />
              </>
            )} */}

          <Button
            variant="heavy"
            mt="30px"
            w="100%"
            h="40px"
            p="4px"
            isLoading={editUserMutation.isLoading}
            isDisabled={(currentLoad != 0 && (inputs[1].length == 0 || inputs[2].length == 0)) || inputs[0].length == 0}
            onClick={async () => {
              if (validateData()) {
                if (currentLoad == 0) {
                  editUserMutation.mutate({
                    phone_number: index + inputs[0],
                  })
                } else if (currentLoad == 1) {
                  const validPassword = await isPasswordCorrect(inputs[1])

                  if (validPassword) {
                    editUserMutation.mutate({
                      email: inputs[2],
                    })
                  } else {
                    setPasswordError(true)
                  }
                } else {
                  const validPassword = await isPasswordCorrect(inputs[0])
                  if (validPassword) {
                    editUserMutation.mutate({
                      password: inputs[2],
                    })
                  } else {
                    setPasswordError(true)
                  }
                }
              }
            }}
          >
            Save
          </Button>
        </Box>
      )}
    </>
  )
}

const UserEventHistoryPage = ({ isMobile }: { isMobile?: boolean }) => {
  const events = useInfiniteQuery(
    ['getEventHistory'],
    ({ pageParam = 1 }) =>
      getUpcomingEvents({
        page: pageParam,
        page_size: 10,
      }),
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage?.hasNext) {
          return null
        }
        return lastPage.nextCursor
      },
    }
  )

  return (
    <Box maxWidth="600px">
      {!isMobile && (
        <Text variant="title" mb="10px">
          Activity
        </Text>
      )}
      <Text color="#3b3b3b" mb="30px" fontWeight="400">
        Check your event history here
      </Text>
      {!events.isLoading && (getInfinityPages(events, 'events').length ?? 0) == 0 && (
        <>
          <BlankState
            title="No events"
            description="You haven't attended any events yet."
            image="blank/No upcoming events 2.svg"
          />
        </>
      )}

      {events.isLoading &&
        [1, 1, 1, 1, 1, 1].map((_: any, index: number) => (
          <Skeleton borderRadius="10px" mb="20px" h="356px" maxW="600px" key={index} />
        ))}
      <InfinityGrid
        isLoading={events.isLoading}
        hasNextPage={events.hasNextPage ?? false}
        onLoadMore={() => events.fetchNextPage()}
        isFetchingNextPage={events.isFetchingNextPage}
      >
        {getInfinityPages(events, 'events').map((event: any, index: number) => {
          return (
            <Box key={index}>
              {(index === 0 ||
                !isSameDay(
                  new Date(event.start_time),
                  new Date(getInfinityPages(events, 'events')[index - 1].start_time)
                )) && (
                  <Text variant="title" fontSize="17px" mb="4px" mt="20px">
                    {new Date(event.start_time).toLocaleString('en-US', {
                      weekday: 'long',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </Text>
                )}

              <EventDetailCard
                isPrivateClass={event?.type == 'private_class'}
                status={event?.status?.status}
                location={event.venue?.name}
                id={event.id}
                time={new Date(event.start_time)}
                type={event.type}
                court={event?.court}
                secondary_type={event?.secondary_type}
                level={getSkillLevelDisplay(event?.skill_level)}
                coaches={event?.coaches}
                host={event?.host}
                players={event?.participants}
                description={event?.description}
                price={parseInt(event.fee)}
                duration={event?.duration}
                onOpenWaitlist={() => { }}
                singleCoach={event?.coach}
              />

              <Spacer h="20px" />
            </Box>
          )
        })}
      </InfinityGrid>
    </Box>
  )
}

const UserIndexNotificationsPage = ({ isMobile }: { isMobile?: boolean }) => {
  return (
    <Box maxW="600px">
      {!isMobile && <Text variant="title">Notifications</Text>}
      <Text color="#3b3b3b" mb="30px" fontWeight="400" mt="10px">
        Control your notification preferences
      </Text>

      <SettingNavButton label="Push notifications" url="/user/settings/notifications-push" isMobile />
      <SettingNavButton label="Email notifications" url="/user/settings/notifications-email" isMobile />
    </Box>
  )
}

const UserPushNotificationsPage = ({
  isMobile,
  notificationSettings,
}: {
  isMobile?: boolean
  notificationSettings: any
}) => {
  const queryClient = useQueryClient()

  // const notificationSettings = useQuery(["getNotificationSettings"], () => getNotificationSettings(), {
  // })

  const updateNotificationSettings = useMutation(['putNotificationSettings'], patchNotificationSettings, {
    // onSuccess : () => {
    //     queryClient.invalidateQueries('getNotificationSettings')
    // },
    onMutate: async (newData: any) => {
      await queryClient.cancelQueries(['getNotificationSettings'])

      const previousData = queryClient.getQueryData(['getNotificationSettings'])

      queryClient.setQueryData(['getNotificationSettings'], (old: any) => {
        return {
          ...old,
          ...newData,
        }
      })
      return previousData
    },
    onError: (err, variables, previousData) => {
      console.error('Error: ', err, 'Object: ', variables)
      queryClient.setQueryData(['getNotificationSettings'], previousData)
    },
    onSettled: async () => {
      await queryClient.cancelQueries(['getNotificationSettings'])
      queryClient.invalidateQueries(['getNotificationSettings'])
    },
  })

  const pushNotifications = notificationSettings.data?.push_notifications ?? []

  const updateSettings = (type: string, active: boolean, follows_only: boolean | null) => {
    const newSettings = active
      ? [...pushNotifications, type]
      : pushNotifications.filter((notif: string) => notif !== type)

    if (follows_only !== null) {
      updateNotificationSettings.mutate({
        push_notifications: newSettings,
        push_notifications_followed_only: follows_only,
      })
    } else {
      updateNotificationSettings.mutate({
        push_notifications: newSettings,
      })
    }
  }

  const updateAll = (active: boolean) => {
    updateNotificationSettings.mutate({
      push_notifications_enabled: !active,
    })
  }

  return (
    <Box maxW="600px">
      {!isMobile && <Text variant="title">Notifications</Text>}
      <Text color="#3b3b3b" mb="30px" fontWeight="400" mt="10px">
        Control your notification preferences
      </Text>

      <Text variant="title" fontSize="lg" mb="10px">
        Push notifications
      </Text>
      <Flex alignItems="center" justifyContent="space-between" mb="30px">
        <Text color="#3b3b3b" fontWeight="400">
          Pause all
        </Text>
        <Switch
          isChecked={!notificationSettings.data?.push_notifications_enabled}
          onChange={() => updateAll(notificationSettings.data?.push_notifications_enabled)}
        />
      </Flex>

      <Text variant="title" fontSize="lg" mb="10px" mt="30px">
        Likes and comments on your posts
      </Text>
      <RadioGroup
        onChange={(e: any) => {
          if (e === '0') {
            updateSettings('comment', false, null)
          } else if (e === '1') {
            updateSettings('comment', true, true)
          } else if (e === '2') {
            updateSettings('comment', true, false)
          }
        }}
        value={
          !pushNotifications.includes('comment')
            ? '0'
            : notificationSettings.data?.push_notifications_followed_only
              ? '1'
              : '2'
        }
      >
        <Stack direction="column">
          <Radio value="0">Off</Radio>
          <Radio value="1">From profiles I follow</Radio>
          <Radio value="2">From everyone</Radio>
        </Stack>
      </RadioGroup>
      <Text m="10px 0" variant="subtle" fontSize="sm">
        LVBL Coach liked and commented on your photo.
      </Text>
      <Divider />

      <Text variant="title" fontSize="lg" mb="10px" mt="30px">
        New followers
      </Text>
      <RadioGroup
        onChange={(value: string) => updateSettings('follow', value === '1', null)}
        value={pushNotifications.includes('follow') ? '1' : '0'}
      >
        <Stack direction="column">
          <Radio value="0">Off</Radio>
          <Radio value="1">On</Radio>
        </Stack>
      </RadioGroup>
      <Text m="10px 0" variant="subtle" fontSize="sm">
        LVBL Coach started following you.
      </Text>
      <Divider />

      <Text variant="title" fontSize="lg" mb="10px" mt="30px">
        Event invites
      </Text>
      <RadioGroup
        onChange={(value: string) => updateSettings('event_invite', value === '1', null)}
        value={pushNotifications.includes('event_invite') ? '1' : '0'}
      >
        <Stack direction="column">
          <Radio value="0">Off</Radio>
          <Radio value="1">On</Radio>
        </Stack>
      </RadioGroup>
      <Text m="10px 0" variant="subtle" fontSize="sm">
        LVBL Coach wants to invite you to a game.
      </Text>
      <Divider />
    </Box>
  )
}

const UserEmailNotificationsPage = ({
  isMobile,
  notificationSettings,
}: {
  isMobile?: boolean
  notificationSettings: any
}) => {
  // const [feedback,setFeedback] = useState('0')
  // const [product,setProduct] = useState('0')
  // const [promotional,setPromotional] = useState('0')
  // const [support,setSupport] = useState('0')

  const queryClient = useQueryClient()

  const updateNotificationSettings = useMutation(['putNotificationSettings'], patchNotificationSettings, {
    // onSuccess : () => {
    //     queryClient.invalidateQueries('getNotificationSettings')
    // },
    onMutate: async (newData: any) => {
      await queryClient.cancelQueries(['getNotificationSettings'])

      const previousData = queryClient.getQueryData(['getNotificationSettings'])

      queryClient.setQueryData(['getNotificationSettings'], (old: any) => {
        return {
          ...old,
          ...newData,
        }
      })
      return previousData
    },
    onError: (err, variables, previousData) => {
      console.error('Error: ', err, 'Object: ', variables)
      queryClient.setQueryData(['getNotificationSettings'], previousData)
    },
    onSettled: async () => {
      await queryClient.cancelQueries(['getNotificationSettings'])
      queryClient.invalidateQueries(['getNotificationSettings'])
    },
  })

  const emailNotifications = notificationSettings.data?.email_notifications ?? []

  const updateSettings = (type: string, active: boolean) => {
    const newSettings = active
      ? [...emailNotifications, type]
      : emailNotifications.filter((notif: string) => notif !== type)

    updateNotificationSettings.mutate({
      email_notifications: newSettings,
    })
  }

  const updateAll = (active: boolean) => {
    updateNotificationSettings.mutate({
      email_notifications_enabled: !active,
    })
  }

  return (
    <Box maxW="600px">
      {!isMobile && <Text variant="title">Notifications</Text>}
      <Text color="#3b3b3b" mb="30px" fontWeight="400" mt="10px">
        Control your notification preferences
      </Text>

      <Text variant="title" fontSize="lg" mb="10px">
        Email notifications
      </Text>
      <Flex alignItems="center" justifyContent="space-between" mb="30px">
        <Text color="#3b3b3b" fontWeight="400">
          Pause all
        </Text>
        <Switch
          isChecked={!notificationSettings.data?.email_notifications_enabled}
          onChange={() => updateAll(notificationSettings.data?.email_notifications_enabled)}
        />
      </Flex>

      <Text variant="title" fontSize="lg" mb="10px" mt="30px">
        Feedback emails
      </Text>
      <RadioGroup
        onChange={(value: string) => updateSettings('feedback', value === '1')}
        value={emailNotifications.includes('feedback') ? '1' : '0'}
      >
        <Stack direction="column">
          <Radio value="0">Off</Radio>
          <Radio value="1">On</Radio>
        </Stack>
      </RadioGroup>
      <Divider mt="10px" />

      <Text variant="title" fontSize="lg" mb="10px" mt="30px">
        Product emails
      </Text>
      <RadioGroup
        onChange={(value: string) => updateSettings('product', value === '1')}
        value={emailNotifications.includes('product') ? '1' : '0'}
      >
        <Stack direction="column">
          <Radio value="0">Off</Radio>
          <Radio value="1">On</Radio>
        </Stack>
      </RadioGroup>
      <Divider mt="10px" />

      <Text variant="title" fontSize="lg" mb="10px" mt="30px">
        Promotional emails
      </Text>
      <RadioGroup
        onChange={(value: string) => updateSettings('promotional', value === '1')}
        value={emailNotifications.includes('promotional') ? '1' : '0'}
      >
        <Stack direction="column">
          <Radio value="0">Off</Radio>
          <Radio value="1">On</Radio>
        </Stack>
      </RadioGroup>
      <Divider mt="10px" />

      <Text variant="title" fontSize="lg" mb="10px" mt="30px">
        Support emails
      </Text>
      <RadioGroup
        onChange={(value: string) => updateSettings('support', value === '1')}
        value={emailNotifications.includes('support') ? '1' : '0'}
      >
        <Stack direction="column">
          <Radio value="0">Off</Radio>
          <Radio value="1">On</Radio>
        </Stack>
      </RadioGroup>
      <Divider mt="10px" />
    </Box>
  )
}

const UserWalletPage = ({ isMobile }: { isMobile?: boolean }) => {
  const [type, setType] = useState('')

  const payments = useInfiniteQuery(
    ['getPayments', type],
    ({ pageParam = 1 }) =>
      getPayments({
        type: type,
        page: pageParam,
        page_size: 10,
      }),
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage?.hasNext) {
          return null
        }
        return lastPage.nextCursor
      },
    }
  )

  const queryClient = useQueryClient()

  const packages = useQuery(['getWalletPackages'], getWalletPackages)

  console.debug(packages.data)

  const navigate = useNavigate()

  const [token, setToken] = useState<string | null>(null)

  useQuery(['getSessionToken'], () => postSessionToken(), {
    onSuccess: (res) => {
      setToken(res.token)
    },
    onError: (error) => {
      console.debug(error)
    },
  })

  const availablePackages = useInfiniteQuery(
    ['getPackages'],
    ({ pageParam = 1 }) =>
      getPackages({
        page: pageParam,
        page_size: 30,
        not_owned: true,
      }),
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage?.hasNext) {
          return null
        }
        return lastPage.nextCursor
      },
    }
  )

  const [timeframe, setTimeframe] = useState('')

  function calculateDates() {
    const now = new Date()

    const oneWeekBefore = subWeeks(now, 1)
    const oneMonthAgo = subMonths(now, 1)
    const oneYearAgo = subYears(now, 1)

    if (timeframe === 'week') {
      return format(oneWeekBefore, 'yyyy-MM-dd HH:mm:ss')
    } else if (timeframe === 'month') {
      return format(oneMonthAgo, 'yyyy-MM-dd HH:mm:ss')
    } else if (timeframe === 'year') {
      return format(oneYearAgo, 'yyyy-MM-dd HH:mm:ss')
    } else {
      return undefined
    }
  }

  const coachReports = useInfiniteQuery(
    ['getCoachReports', timeframe],
    ({ pageParam = 1 }) =>
      getCoachReports({
        page: pageParam,
        page_size: 10,
        min_date: calculateDates(),
      }),
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage?.hasNext) {
          return null
        }
        return lastPage.nextCursor
      },
    }
  )

  const { onOpen: onDatePickerOpen, onClose: onDatePickerClose, isOpen: isDatePickerOpen } = useDisclosure()

  const [packageId, setPackageId] = useState<string | null>(null)

  const toast = useToast()

  const availability = useQuery(
    ['bookingAvailability', packageId],
    () =>
      getCoachAvailability({
        id: packageId ?? '',
      }),
    {
      enabled: packageId !== null,
    }
  )

  const [bookTime, setBookTime] = useState<Date | null>(null)
  const [duration, setDuration] = useState<number | null>(null)

  const bookClass = useMutation(['placeBooking'], putBooking, {
    onSuccess: () => {
      queryClient.invalidateQueries('bookingAvailability')
      onDatePickerClose()
      queryClient.invalidateQueries('getWalletPackages')
      handleToast(toast, 'Class booked successfully')

      generateICS(bookTime ?? new Date(), duration ?? 60)
      navigate(
        `/checkout/book/success?package_id=${packageId}&access_token=${token}&booked=yes&booked=yes&isBooked=true`
      )
    },
    onError: () => {
      handleToast(toast, 'An error occurred while booking the class')
    },
  })

  const period = useState(0)[0]

  return (
    <>
      {!isMobile && (
        <Text variant="title" mb="30px">
          My Wallet
        </Text>
      )}

      <DatePickerModal
        isOpen={isDatePickerOpen}
        onClose={onDatePickerClose}
        isLoading={bookClass.isLoading}
        availability={availability}
        onSave={(startTime: string) => {
          setBookTime(new Date(startTime))
          bookClass.mutate({
            id: packageId ?? '',
            data: {
              start_time: startTime,
            },
          })
        }}
      />
      <SimpleGrid
        spacing={10}
        templateColumns="repeat(auto-fit, minmax(350px, 0.3fr))"
        templateRows="auto"
        justifyItems={'center'}
      >
        {(availablePackages.isLoading || packages.isLoading) &&
          [1, 1, 1, 1, 1].map((_, index) => (
            <Skeleton flex="0 0 auto" key={index} h="300px" w="100%" borderRadius="10px" />
          ))}
        {!(availablePackages.isLoading || packages.isLoading) &&
          packages.data?.data.map((pack: any, index: number) => {
            return (
              <>
                <ClassPackWalletCard
                  key={index}
                  thumbnail={
                    pack?.image ||
                    (pack?.type == 'private_class'
                      ? '/cards/private_lesson.svg'
                      : pack?.type == 'skills'
                        ? '/cards/skills.svg'
                        : '/cards/class.svg')
                  }
                  type={pack.title}
                  duration={pack.duration}
                  classesLeft={pack.quantity}
                  onPurchase={() =>
                    navigate(
                      `/checkout/pack?access_token=${token}&coach=${pack.coach?.id}&type=${pack.type}`
                    )
                  }
                  onFindEvent={!pack.coach ? () => navigate('/user/play?type=' + pack.type) : undefined}
                  onBook={() => {
                    onDatePickerOpen()
                    setPackageId(pack.id)
                    setDuration(pack.duration)
                  }}
                  host={pack.coach ? { name: pack.coach?.display_name, id: pack.coach?.id } : undefined}
                />
              </>
            )
          })}
        {!(availablePackages.isLoading || packages.isLoading) &&
          getInfinityPages(availablePackages).map((pack: any, index: number) => {
            return (
              <>
                <ClassPackWalletCard
                  key={index}
                  thumbnail={
                    pack?.image ||
                    (pack?.type == 'private_class'
                      ? '/cards/private_lesson.svg'
                      : pack?.type == 'skills'
                        ? '/cards/skills.svg'
                        : '/cards/class.svg')
                  }
                  type={pack.title}
                  notOwned={true}
                  price={pack.price}
                  duration={pack.duration}
                  classesLeft={pack.amount}
                  onPurchase={
                    () =>
                      navigate(
                        `/checkout/pack?access_token=${token}&coach=${pack.coach?.id}&type=${pack.type}&price=${pack.price}`
                      )
                  }
                  onFindEvent={!pack.coach ? () => navigate('/user/play?type=' + pack.type) : undefined}
                  onBook={() => {
                    onDatePickerOpen()
                    setPackageId(pack.id)
                    setDuration(pack.duration)
                  }}
                  host={pack.coach ? { name: pack.coach?.display_name, id: pack.coach?.id } : undefined}
                />
              </>
            )
          })}
      </SimpleGrid>

      {period == 0 ? (
        <Box>
          <Flex maxW="600px" mt="30px" alignItems="center" justifyContent="space-between">
            <Text variant="title" fontSize="lg">
              Transaction Activity
            </Text>
            <Select
              w={isMobile ? '140px' : '200px'}
              size={isMobile ? 'sm' : 'md'}
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="">All</option>
              <option value="private_class_package">Private Classes</option>
              <option value="event_package">Event Packages</option>
              <option value="event_booking">Event Bookings</option>
            </Select>
          </Flex>
          <Box maxW="600px">
            {!payments.isLoading && getInfinityPages(payments, 'transactions').length == 0 && (
              <BlankState
                title="No transactions"
                description="You have no transactions yet"
                image="blank/There are no events to be found.svg"
              />
            )}
            <InfinityGrid
              isLoading={payments.isLoading}
              hasNextPage={payments.hasNextPage ?? false}
              onLoadMore={() => payments.fetchNextPage()}
              isFetchingNextPage={payments.isFetchingNextPage}
            >
              {payments.isLoading &&
                [1, 1, 1, 1, 1, 1, 1, 1, 1, 1].map((_, index) => (
                  <Skeleton key={index} h="70px" w="100%" m="15px 0" borderRadius="10px" />
                ))}
              {getInfinityPages(payments, 'transactions').map((payment: any, index: number) => {
                return (
                  <>
                    <TransactionActivity
                      key={index}
                      title={payment.label}
                      thumbnail={payment.image ?? '/cards/private_lesson.svg'}
                      date={new Date(payment.date)}
                      amount={payment.price}
                    />
                  </>
                )
              })}
            </InfinityGrid>
          </Box>
        </Box>
      ) : (
        <Box>
          <Flex maxW="600px" mt="30px" alignItems="center" justifyContent="space-between">
            <Text variant="title" fontSize="lg">
              Payments from Hosts
            </Text>
            <Select
              w={isMobile ? '100px' : '200px'}
              size={isMobile ? 'sm' : 'md'}
              value={timeframe}
              onChange={(e) => setTimeframe(e.target.value)}
            >
              <option value="">All</option>
              <option value="week">Last week</option>
              <option value="month">Last month</option>
              <option value="year">Last year</option>
            </Select>
          </Flex>
          <Box maxW="600px">
            {!coachReports.isLoading && getInfinityPages(coachReports, null).length == 0 && (
              <BlankState
                title="No transactions"
                description="You have no transactions yet"
                image="blank/There are no events to be found.svg"
              />
            )}
            <InfinityGrid
              isLoading={coachReports.isLoading}
              hasNextPage={coachReports.hasNextPage ?? false}
              onLoadMore={() => coachReports.fetchNextPage()}
              isFetchingNextPage={coachReports.isFetchingNextPage}
            >
              {coachReports.isLoading &&
                [1, 1, 1, 1, 1, 1, 1, 1, 1, 1].map((_, index) => (
                  <Skeleton key={index} h="70px" w="100%" m="15px 0" borderRadius="10px" />
                ))}
              {getInfinityPages(coachReports, null).map((payment: any, index: number) => {
                return (
                  <>
                    <TransactionActivity
                      key={index}
                      title={payment.event.title}
                      thumbnail={payment.image ?? '/cards/private_lesson.svg'}
                      date={new Date(payment.event.start_time)}
                      amount={payment.fixed_rate + (payment.duration * payment.hourly_rate) / 60}
                      file={payment.report}
                    />
                  </>
                )
              })}
            </InfinityGrid>
          </Box>
        </Box>
      )}
    </>
  )
}

const UserPaymentsPage = ({ isMobile }: { isMobile: boolean }) => {
  const [dataType, setDataType] = useState(0)

  const [paymentMethod, setPaymentMethod] = useState(0)

  /* Comment back in once the endpoint for determining whether's bank account was incorrect */
  //const [ isError, setIsError ] = useState(false)

  const [step, setStep] = useState(0)

  const [earningsFilter, setEarningsFilter] = useState('')
  const [graphFilter, setGraphFilter] = useState(0)
  const [transactionFilter, setTransactionFilter] = useState(0)

  const FILTERS = ['D', 'W', 'M', 'Q', 'H']
  const PERIOD = ['TRUE', 'FALSE']

  const payouts = useInfiniteQuery(
    ['getPayouts', earningsFilter],
    ({ pageParam = 1 }) =>
      getPayouts({
        amount: earningsFilter == 'amount' ? 'amount' : null,
        page: pageParam,
        page_size: 10,
      }),
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage?.hasNext) {
          return null
        }
        return lastPage.nextCursor
      },
    }
  )

  const transactions = useInfiniteQuery(
    ['getTransactions', transactionFilter],
    ({ pageParam = 1 }) =>
      getTransactions({
        prev: PERIOD[transactionFilter % 2],
        period: FILTERS[Math.floor(transactionFilter / 2)],
        page: pageParam,
        page_size: 10,
      }),
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage?.hasNext) {
          return null
        }
        return lastPage.nextCursor
      },
    }
  )

  const graph = useQuery(['getGraph', graphFilter], () =>
    getTransactionsGraph({
      prev: PERIOD[graphFilter % 2],
      period: FILTERS[Math.floor(graphFilter / 2)],
    })
  )

  const bankAccount = useQuery(['getBankDetails'], () => getBankAccount())

  const [clickedOnce, setClickedOnce] = useState(false)

  const payoutExists: boolean = bankAccount.data?.data.stripe_account_complete
  const isError = bankAccount.data?.data.stripe_account_error

  // const payoutExists : boolean = !(
  //     bankAccount.data?.data.country == "" ||
  //     bankAccount.data?.data.account_type == "" ||
  //     bankAccount.data?.data.account_name == "" ||
  //     bankAccount.data?.data.routing_number == "" ||
  //     bankAccount.data?.data.account_number == ""
  // )

  const [formData, setFormData] = useState({
    country: 'US',
    account_type: 'checkings',
    account_name: '',
    routing_number: '',
    account_number: '',
    confirm_account_number: '',
  })

  const [errors, setErrors] = useState({
    account_name: false,
    routing_number: false,
    account_number: false,
    confirm_account_number: false,
  })

  const validateData = () => {
    const errors = {
      account_name: formData.account_name === '',
      routing_number: !validator.isNumeric(formData.routing_number) || formData.routing_number.length !== 9,
      account_number:
        !validator.isNumeric(formData.account_number) ||
        formData.account_number.length < 5 ||
        formData.account_number.length > 17,
      confirm_account_number: formData.confirm_account_number !== formData.account_number,
    }

    setErrors(errors)

    return !Object.values(errors).includes(true)
  }

  const queryClient = useQueryClient()
  const toast = useToast()

  const addBankAccount = useMutation(['addBankAccount'], putBankAccount, {
    onSuccess: () => {
      setStep(0)
      queryClient.invalidateQueries(['getBankDetails'])
      handleToast(toast, 'Bank account added successfully')
    },
  })

  const { isOpen, onOpen, onClose } = useDisclosure()
  const openCapacitorSite = async (url: string) => {
    await Browser.open({ url: url })
  }

  return (
    <>
      <Box maxW="900px">
        {step > 0 ? (
          <>
            <Flex gap="8px" mb="30px">
              <IconButton
                minW="32px"
                h="32px"
                variant="light"
                aria-label="back"
                onClick={() => setStep(step - 1)}
                icon={
                  <Icon width="20px" height="20px" viewBox="0 0 20 20">
                    <ArrowLeft color="#171C22" />
                  </Icon>
                }
              />
              <Center>
                <Text variant="title">Set up payouts</Text>
              </Center>
            </Flex>

            {step == 2 && (
              <Text fontSize="lg" fontWeight="500" color="#171C22">
                Add bank account info
              </Text>
            )}

            <Box margin="auto" maxW="440">
              {step == 1 ? (
                <>
                  <Text mt="12px" color="#171C22" fontWeight="500" fontSize="lg">
                    Let's add a payout method
                  </Text>
                  <Text mt="4px" mb="12px" color="#7E8B9A" fontWeight="500" fontSize="md">
                    To start, let us know where you'd like us to send your money
                  </Text>

                  <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
                    Billing country/region
                  </Text>
                  <Select
                    maxWidth="440px"
                    borderWidth="1px"
                    borderColor="#171C22"
                    borderRadius="4px"
                    m="4px 0"
                    value={formData.country}
                    onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                  >
                    {countries.map((country: any, index: number) => {
                      return (
                        <option key={index} value={country.code}>
                          {country.name}
                        </option>
                      )
                    })}
                  </Select>

                  <Text>
                    <Text as="span" color="#7E8B9A" fontWeight="400" fontSize="xs">
                      This is where you opened your financial account.
                    </Text>
                    <Text as="span" ml="4px" textDecoration="underline" fontWeight="400" fontSize="md" color="#171C22">
                      More info
                    </Text>
                  </Text>

                  <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
                    How would you like to get paid?
                  </Text>
                  <Text mt="4px" mb="12px" color="#7E8B9A" fontWeight="500" fontSize="md">
                    Payouts will be sent in USD
                  </Text>

                  <Box
                    p="20px"
                    maxWidth="440px"
                    border="0.5px solid #DCE2EA"
                    boxShadow="0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14"
                    borderRadius="10px"
                  >
                    <Flex justifyContent="space-between" alignItems="center">
                      <Flex gap="8px">
                        <Icon w="20px" h="20px" viewBox="0 0 20 20" fill="none">
                          <Government />
                        </Icon>
                        <Text>Bank account</Text>
                      </Flex>
                      <Box
                        transition="0.2s ease-out"
                        onClick={() => setPaymentMethod(0)}
                        bg={paymentMethod == 0 ? 'black' : 'transparent'}
                        border={paymentMethod == 0 ? 'none' : '1px solid #DCE2EA'}
                        w="14px"
                        h="14px"
                        borderRadius="50%"
                        cursor="pointer"
                      />
                    </Flex>

                    <UnorderedList ml="40px" spacing={0}>
                      <ListItem>
                        <Text variant="subtle" fontSize="15px">
                          3-5 business days
                        </Text>
                      </ListItem>
                      <ListItem>
                        <Text variant="subtle" fontSize="15px">
                          No fees
                        </Text>
                      </ListItem>
                    </UnorderedList>
                  </Box>

                  <Text mt="12px" color="#7E8B9A" fontWeight="400" fontSize="xs">
                    Payout take longer for some banks, and reviews could result in holds or delays
                  </Text>
                  <Text mt="8px" mb="8px" textDecoration="underline" fontWeight="400" fontSize="md" color="#171C22">
                    Learn more
                  </Text>

                  <Button
                    variant="heavy"
                    width="100%"
                    p="18px 20px"
                    fontSize="lg"
                    h="58px"
                    onClick={() => setStep(step + 1)}
                  >
                    Continue
                  </Button>
                </>
              ) : (
                <>
                  <Text mt="24px" fontSize="lg" mb="4px" fontWeight="500" color="#171C22">
                    Is this a checking or savings account?
                  </Text>

                  <RadioGroup
                    mt="8px"
                    defaultValue="1"
                    value={formData.account_type == 'checkings' ? '1' : '2'}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        account_type: e == '1' ? 'checkings' : 'savings',
                      })
                    }
                  >
                    <Stack>
                      <Radio size="md" value="1">
                        Checkings
                      </Radio>
                      <Radio size="md" value="2">
                        Savings
                      </Radio>
                    </Stack>
                  </RadioGroup>

                  <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
                    Account holder name
                  </Text>

                  <Input
                    borderColor="black"
                    placeholder="Enter account holder name"
                    value={formData.account_name}
                    onChange={(e) => setFormData({ ...formData, account_name: e.target.value })}
                  />
                  <InvalidInput isError={errors.account_name} override="Field can't be empty" />

                  <Text mt="12px" color="#7E8B9A" fontWeight="400" fontSize="xs">
                    Enter the account holder's name exactly as it appears on bank statements.
                  </Text>

                  <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
                    Routing number
                  </Text>

                  <Input
                    borderColor="black"
                    placeholder="Enter routing number"
                    value={formData.routing_number}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        routing_number: e.target.value,
                      })
                    }
                  />
                  <InvalidInput isError={errors.routing_number} override="Invalid routing number" />

                  <Text mt="12px" color="#7E8B9A" fontWeight="400" fontSize="xs">
                    Enter the routing number. It is located on the bottom left corner of a check or within account
                    details from the bank.
                  </Text>

                  <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
                    Account number
                  </Text>

                  <Input
                    borderColor="black"
                    placeholder="Enter account number"
                    value={formData.account_number}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        account_number: e.target.value,
                      })
                    }
                  />
                  <InvalidInput isError={errors.account_number} override="Invalid account number" />

                  <Input
                    mt="26px"
                    borderColor="black"
                    placeholder="Confirm account number"
                    value={formData.confirm_account_number}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        confirm_account_number: e.target.value,
                      })
                    }
                  />
                  <InvalidInput isError={errors.confirm_account_number} override="Account numbers don't match" />

                  <Text mt="12px" color="#7E8B9A" fontWeight="400" fontSize="xs">
                    Enter the account number. This can usually be found within the account details.
                  </Text>

                  <Button
                    variant="heavy"
                    mt="36px"
                    width="100%"
                    p="18px 20px"
                    h="58px"
                    isLoading={addBankAccount.isLoading}
                    onClick={() => {
                      if (validateData()) {
                        addBankAccount.mutate(formData)
                      }
                    }}
                  >
                    <Icon w="24px" h="24px" viewBox="0 0 24 24">
                      <CreditCard2 />
                    </Icon>
                    <Text fontSize="lg" ml="8px">
                      Add Bank Account
                    </Text>
                  </Button>
                </>
              )}
            </Box>
          </>
        ) : (
          <Box maxW="675px">
            {!isMobile && (
              <Text variant="title" mb="30px">
                Payments
              </Text>
            )}

            <Tabs align="center" index={dataType} onChange={(i) => setDataType(i)}>
              <TabList>
                <CustomTab w="180px">Reporting & Activity</CustomTab>
                <CustomTab w="120px">Payouts</CustomTab>
              </TabList>
            </Tabs>

            {dataType == 0 ? (
              <>
                <CoachReportModal isOpen={isOpen} onClose={onClose} />
                <Text mt="12px" color="#171C22" fontWeight="500" fontSize="lg">
                  Manage your earnings and activity
                </Text>
                <Text mt="4px" mb="12px" color="#7E8B9A" fontWeight="500" fontSize="md">
                  Lorem ipsum dolor sit amet consectetur. Scelerisque
                </Text>

                <Box
                  border="0.5px solid #DCE2EA"
                  boxShadow="0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14"
                  borderRadius="10px"
                  p="30px"
                >
                  <Flex justifyContent="space-between">
                    <Text fontSize="2xl" color="#171C22" fontWeight="500">
                      Overview
                    </Text>
                    <Select
                      w="auto"
                      borderRadius="44px"
                      pl="30px"
                      fontSize="md"
                      bgColor="#F5F7F9"
                      color="#171C22"
                      value={graphFilter}
                      onChange={(e) => setGraphFilter(parseInt(e.target.value))}
                    >
                      <option value="0">Today</option>
                      <option value="1">Yesterday</option>
                      <option value="2">This week</option>
                      <option value="3">Last week</option>
                      <option value="4">This month</option>
                      <option value="5">Last month</option>
                      <option value="6">This quarter</option>
                      <option value="7">Last quarter</option>
                      <option value="8">Last 6 months</option>
                      <option value="9">Last 12 months</option>
                    </Select>
                  </Flex>

                  <Flex mt="24px" gap="4px">
                    <Icon w="24px" h="24px" viewBox="0 0 24 24" fill="none">
                      <Coins />
                    </Icon>
                    <Text fontSize="md" color="#171C22" fontWeight="500">
                      Total Earnings
                    </Text>
                  </Flex>

                  <Skeleton isLoaded={!graph.isLoading} w="240px">
                    <Text color="#171C22" fontSize="44px" fontWeight="700">
                      ${graph?.data?.total}
                    </Text>
                  </Skeleton>

                  <Divider w="75px" borderWidth="1px" mt="4px" />

                  <Text m="10px 0" color="#7E8B9A" mb="30px" fontWeight="400" fontSize="sm">
                    Lorem ipsum dolor sit amet consectetur. Aliquam enim scelerisque donec.
                  </Text>

                  {graph.isLoading ? (
                    <Skeleton w="100%" h="200px" />
                  ) : (
                    <PaymentChart
                      data={
                        graph.data?.data.map((item: any) => {
                          return { ...item, value: item.value }
                        }) ?? []
                      }
                    />
                  )}
                </Box>

                <Button mt="30px" h="35px" borderRadius="170px" onClick={() => onOpen()}>
                  <Icon w="20px" h="20px" viewBox="0 0 20 20">
                    <CircleDownArrow />
                  </Icon>
                  <Center ml="8px">
                    <Text>Download Payout Report for Coaches</Text>
                  </Center>
                </Button>

                <Flex maxW="600px" mt="30px" alignItems="center" justifyContent="space-between">
                  <Text variant="title" fontSize="lg">
                    Transaction Activity
                  </Text>
                  <Select
                    w={isMobile ? '150px' : '200px'}
                    size={isMobile ? 'sm' : 'md'}
                    value={transactionFilter}
                    onChange={(e) => setTransactionFilter(parseInt(e.target.value))}
                  >
                    <option value="0">Today</option>
                    <option value="1">Yesterday</option>
                    <option value="2">This week</option>
                    <option value="3">Last week</option>
                    <option value="4">This month</option>
                    <option value="5">Last month</option>
                    <option value="6">This quarter</option>
                    <option value="7">Last quarter</option>
                    <option value="8">Last 6 months</option>
                    <option value="9">Last 12 months</option>
                  </Select>
                </Flex>
                <Box maxW="600px">
                  {!transactions.isLoading && getInfinityPages(transactions).length == 0 && (
                    <BlankState
                      title="No transactions"
                      description="You have no transactions yet"
                      image="blank/There are no events to be found.svg"
                    />
                  )}
                  {transactions.isLoading &&
                    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1].map((_, index) => (
                      <Skeleton key={index} h="70px" w="100%" m="15px 0" borderRadius="10px" />
                    ))}
                  <InfinityGrid
                    isLoading={transactions.isLoading}
                    hasNextPage={transactions.hasNextPage ?? false}
                    onLoadMore={() => transactions.fetchNextPage()}
                    isFetchingNextPage={transactions.isFetchingNextPage}
                  >
                    {getInfinityPages(transactions).map((transaction: any, index: number) => {
                      return (
                        <TransactionActivity
                          key={index}
                          title={transaction.label}
                          thumbnail={transaction.image}
                          date={new Date(transaction.timestamp)}
                          amount={transaction.amount}
                          file={transaction.report_pdf}
                        />
                      )
                    })}
                  </InfinityGrid>
                </Box>
              </>
            ) : (
              <>
                {bankAccount.isLoading ? (
                  <>
                    <Center h="300px">
                      <Spinner size="xl" color="black" />
                    </Center>
                  </>
                ) : (
                  <>
                    {payoutExists ? (
                      <>
                        {isError && (
                          <Flex
                            mt="30px"
                            p="20px"
                            bgColor="#FF3B301A"
                            borderRadius="10px"
                            border="0.5px solid #FF3B30"
                            justifyContent="space-between"
                          >
                            <Flex>
                              <Center>
                                <Icon w="24px" h="24px" viewBox="0 0 24 24" fill="none">
                                  <TriangleAlert />
                                </Icon>
                              </Center>
                              <Center>
                                <Text ml="16px" fontWeight="500" fontSize="lg" color="#FF3B30">
                                  There has been an issue with your payout
                                </Text>
                              </Center>
                            </Flex>
                            <Center>
                              <Text fontWeight="500" fontSize="lg" color="#171C22">
                                Try Again
                              </Text>
                            </Center>
                          </Flex>
                        )}

                        <Box
                          border="0.5px solid #DCE2EA"
                          boxShadow="0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14"
                          borderRadius="10px"
                          p="20px"
                          m="30px 0"
                        >
                          <Flex justifyContent="space-between">
                            <Flex>
                              <Center w="48px" h="48px" bgColor="#F5F7F9" borderRadius="10px">
                                <Icon w="20px" h="20px" viewBox="0 0 20 20" fill="none">
                                  <Government />
                                </Icon>
                              </Center>
                              <Center>
                                <Text ml="16px" fontWeight="500" fontSize="lg" color="#171C22">
                                  Bank account ending in {bankAccount.data?.data.bank_account_digits}
                                </Text>
                              </Center>
                            </Flex>
                            <Center>
                              <Text
                                ml="16px"
                                fontWeight="500"
                                fontSize="lg"
                                color="#171C22"
                                opacity={bankAccount.isLoading || clickedOnce ? '50%' : ''}
                                cursor="pointer"
                                onClick={() => {
                                  //setStep(1)}
                                  if (bankAccount.isLoading || clickedOnce) return

                                  setClickedOnce(true)
                                  if (isMobile) {
                                    openCapacitorSite(bankAccount.data?.data.stripe_account_session)
                                  } else {
                                    window.location.href = bankAccount.data?.data.stripe_account_session
                                  }
                                }}
                              >
                                Edit
                              </Text>
                            </Center>
                          </Flex>
                        </Box>

                        <Flex gap="64px" mb="16px">
                          <Skeleton isLoaded={!payouts.isLoading} w="160px">
                            <Text color="#7E8B9A" fontSize="lg" fontWeight="500">
                              Balance
                            </Text>
                            <Text color="#171C22" fontSize="5xl" fontWeight="600">
                              ${payouts?.data?.pages[0].balance}
                            </Text>
                          </Skeleton>
                          <Skeleton isLoaded={!payouts.isLoading} w="160px">
                            <Text color="#7E8B9A" fontSize="lg" fontWeight="17px">
                              Total Paid to Date
                            </Text>
                            <Text color="#171C22" fontSize="5xl" fontWeight="600">
                              ${payouts?.data?.pages[0].total}
                            </Text>
                          </Skeleton>
                        </Flex>

                        <Text fontWeight="500" fontSize="md" mb="16px">
                          <Text as="span" color="#171C22">
                            Next payout scheduled for{' '}
                          </Text>
                          <Text as="span" color="#06C270">
                            01/18/24
                          </Text>
                        </Text>

                        <Flex justifyContent="space-between" mb="8px">
                          <Center>
                            <Text color="#171C22" fontWeight="500" fontSize="lg">
                              Payout history
                            </Text>
                          </Center>
                          <Select
                            w="auto"
                            borderRadius="44px"
                            bgColor="#F5F7F9"
                            value={earningsFilter}
                            onChange={(e) => setEarningsFilter(e.target.value)}
                            icon={
                              <Icon w="18px" h="18px" viewBox="0 0 18 18">
                                <DecreasingLines />
                              </Icon>
                            }
                          >
                            <option value="">Most Recent</option>
                            <option value="amount">Amount</option>
                          </Select>
                        </Flex>

                        <Text mt="12px" color="#7E8B9A" fontWeight="400" fontSize="md" mb="12px">
                          You can check and sort your payment history
                        </Text>
                        {payouts.isLoading &&
                          [1, 1, 1, 1, 1, 1, 1, 1, 1, 1].map((_, index) => (
                            <Skeleton key={index} h="40px" w="100%" m="15px 0" borderRadius="10px" />
                          ))}
                        <InfinityGrid
                          isLoading={payouts.isLoading}
                          hasNextPage={payouts.hasNextPage ?? false}
                          onLoadMore={() => payouts.fetchNextPage()}
                          isFetchingNextPage={payouts.isFetchingNextPage}
                        >
                          {getInfinityPages(payouts).map((payout: any, index: number) => {
                            const onDownload = async () => {
                              const blob = new Blob([payout.report], {
                                type: 'application/json',
                              })
                              const url = window.URL.createObjectURL(blob)

                              const res = await checkFileSystemPermissions()

                              if (!res) return

                              const directory = Directory.Documents

                              const filePath = await Filesystem.writeFile({
                                path: `payout-report-${new Date(payout.created_at).toLocaleDateString('en-US', {
                                  month: '2-digit',
                                  day: '2-digit',
                                  year: 'numeric',
                                })}.pdf`,
                                data: url,
                                directory: directory,
                                encoding: Encoding.UTF8,
                                recursive: true,
                              })

                              try {
                                const fileOpenerOptions: FileOpenerOptions = {
                                  filePath: filePath.uri,
                                  contentType: 'application/pdf',
                                  openWithDefault: true,
                                }
                                await FileOpener.open(fileOpenerOptions)
                              } catch (e) {
                                console.debug('Error opening file', e)
                              }
                            }

                            const handleDownload = () => {
                              const blob = new Blob([payout.report], {
                                type: 'application/json',
                              })

                              const url = window.URL.createObjectURL(blob)
                              const a = document.createElement('a')
                              a.href = url
                              a.download = `payout-report-${new Date(payout.created_at).toLocaleDateString('en-US', {
                                month: '2-digit',
                                day: '2-digit',
                                year: 'numeric',
                              })}.pdf`

                              document.body.appendChild(a)
                              a.click()
                              a.remove()
                              URL.revokeObjectURL(url)
                            }

                            return (
                              <Box key={index}>
                                <Flex m="16px 0" justifyContent="space-between">
                                  <Center>
                                    <Text fontSize="md" fontWeight="500">
                                      <Text as="span" color="#171C22">
                                        Date:{' '}
                                      </Text>
                                      <Text as="span" color="#7E8B9A">
                                        {' '}
                                        {new Date(payout.created_at).toLocaleDateString('en-US', {
                                          month: '2-digit',
                                          day: '2-digit',
                                          year: 'numeric',
                                        })}{' '}
                                      </Text>
                                      <Text as="span"> · </Text>
                                      <Text as="span" color="#171C22">
                                        {' '}
                                        Amount:{' '}
                                      </Text>
                                      <Text as="span" color="#7E8B9A">
                                        {' '}
                                        ${payout.amount}{' '}
                                      </Text>
                                    </Text>
                                  </Center>
                                  {!isMobile && (
                                    <Button
                                      h="35px"
                                      borderRadius="170px"
                                      onClick={() => (Capacitor.isNativePlatform() ? onDownload() : handleDownload())}
                                    >
                                      <Icon w="20px" h="20px" viewBox="0 0 20 20">
                                        <CircleDownArrow />
                                      </Icon>
                                      <Center ml="8px">
                                        <Text>Download Report</Text>
                                      </Center>
                                    </Button>
                                  )}
                                </Flex>
                                {isMobile && (
                                  <Flex m="16px 0" justifyContent="space-between">
                                    <Text></Text>
                                    <Button
                                      h="35px"
                                      borderRadius="170px"
                                      onClick={() => (Capacitor.isNativePlatform() ? onDownload() : handleDownload())}
                                    >
                                      <Icon w="20px" h="20px" viewBox="0 0 20 20">
                                        <CircleDownArrow />
                                      </Icon>
                                      <Center ml="8px">
                                        <Text>Download Report</Text>
                                      </Center>
                                    </Button>
                                  </Flex>
                                )}

                                <Divider borderWidth="1px" />
                              </Box>
                            )
                          })}
                        </InfinityGrid>
                      </>
                    ) : (
                      <>
                        <Text mt="12px" color="#171C22" fontWeight="500" fontSize="lg">
                          How you'll get paid
                        </Text>
                        <Text mt="4px" mb="12px" color="#7E8B9A" fontWeight="500" fontSize="md">
                          Add at least one payout method so we know where to send your money
                        </Text>

                        <Button
                          variant="heavy"
                          m="16px 0"
                          mb="36px"
                          isLoading={bankAccount.isLoading || clickedOnce}
                          isDisabled={clickedOnce}
                          onClick={() => {
                            //setStep(1)}
                            setClickedOnce(true)
                            console.debug(bankAccount.data.data.stripe_account_session)
                            if (isMobile) {
                              openCapacitorSite(bankAccount.data?.data.stripe_account_session)
                            } else {
                              window.location.href = bankAccount.data?.data.stripe_account_session
                            }
                          }}
                        >
                          Set up payouts
                        </Button>

                        <Box
                          border="0.5px solid #DCE2EA"
                          boxShadow="0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14"
                          borderRadius="10px"
                          p="20px"
                        >
                          <Text fontWeight="550" color="#171C22" fontSize="lg" m="10px">
                            FAQs
                          </Text>

                          <Accordion allowMultiple>
                            <AccordionItem>
                              <h2>
                                <AccordionButton>
                                  <Box as="span" flex="1" textAlign="left">
                                    When will I get my payout?
                                  </Box>
                                  <AccordionIcon />
                                </AccordionButton>
                              </h2>
                              <AccordionPanel pb={4}>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                              </AccordionPanel>
                            </AccordionItem>

                            <AccordionItem>
                              <h2>
                                <AccordionButton>
                                  <Box as="span" flex="1" textAlign="left">
                                    How do payouts work?
                                  </Box>
                                  <AccordionIcon />
                                </AccordionButton>
                              </h2>
                              <AccordionPanel pb={4}>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                              </AccordionPanel>
                            </AccordionItem>
                            <AccordionItem>
                              <h2>
                                <AccordionButton>
                                  <Box as="span" flex="1" textAlign="left">
                                    Where do I see my transaction history?
                                  </Box>
                                  <AccordionIcon />
                                </AccordionButton>
                              </h2>
                              <AccordionPanel pb={4}>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                              </AccordionPanel>
                            </AccordionItem>
                          </Accordion>
                        </Box>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </Box>
        )}
      </Box>
    </>
  )
}

export const getSettingsPageTitle = (url: string) => {
  if (url.includes('profile')) return 'Account'
  if (url.includes('security')) return 'Security'
  if (url.includes('activity')) return 'Activity'
  if (url.includes('notifications')) return 'Notifications'
  if (url.includes('payments')) return 'Payments'
  if (url.includes('wallet')) return 'My Wallet'
  if (url.includes('tp')) return 'Terms & Policies'
  return 'Settings'
}

const UserSettingsPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const isTablet = useMobile(830)
  const isMobile = useMobile(600)

  const notificationSettings = useQuery(['getNotificationSettings'], () => getNotificationSettings(), {})

  const getPage = () => {
    if (location.pathname.includes('profile')) return <UserSettingsEditProfilePage isMobile={isTablet} />
    else if (location.pathname.includes('security')) return <UserSettingsSecurityPage isMobile={isTablet} />
    else if (location.pathname.includes('activity')) return <UserEventHistoryPage isMobile={isTablet} />
    else if (location.pathname.includes('notifications-push'))
      return <UserPushNotificationsPage isMobile={isTablet} notificationSettings={notificationSettings} />
    else if (location.pathname.includes('notifications-email'))
      return <UserEmailNotificationsPage isMobile={isTablet} notificationSettings={notificationSettings} />
    else if (location.pathname.includes('notifications')) return <UserIndexNotificationsPage isMobile={isTablet} />
    else if (location.pathname.includes('payments')) return <UserPaymentsPage isMobile={isTablet} />
    else if (location.pathname.includes('wallet')) return <UserWalletPage isMobile={isTablet} />
    else if (location.pathname.includes('tp')) return <></>
    else return <NavSection isMobile />
  }

  if (isTablet)
    return (
      <Box w="100%" p="20px">
        {isTablet && !isMobile && (
          <Flex
            minH="32px"
            mb="10px"
            justifyContent="space-between"
            bg="white"
            transition={'0.2s ease-out'}
            overflow="hidden"
            position="relative"
          >
            <Center w="100%" h="100%" position="absolute" left="0" top="0">
              <Text variant="title" fontSize="lg">
                {getSettingsPageTitle(location.pathname)}
              </Text>
            </Center>
            <IconButton
              minW="32px"
              h="32px"
              variant="light"
              aria-label="back"
              onClick={() => navigate(-1)}
              icon={
                <Icon width="20px" height="19px" viewBox="0 0 23 20">
                  <ArrowLeft color="#171C22" />
                </Icon>
              }
            />
          </Flex>
        )}
        {getPage()}
      </Box>
    )

  return (
    <Flex w="100%" h="100vh">
      <NavSection />
      <Divider orientation="vertical" zIndex={1000} />
      <Box
        w="calc(100% - 235px - 1px)"
        p={!location.pathname.includes('profile') ? '30px' : '0'}
        h="100%"
        overflowY="auto"
        sx={scrollbarStyle}
      >
        {getPage()}
      </Box>
    </Flex>
  )
}

export default UserSettingsPage
